/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  This file used to store the API urls thourgh the application in JSON object format
  EX: https://jsonplaceholderqa.typicode.com/api/GetHomeData
*/
/* istanbul ignore file */

const apiUrl = { general: '/api/', case: '/api/Case' }
const apiMethod = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE',
  patch: 'PATCH',
}
const APIEndPoints = {
  getCaseData: {
    url: apiUrl?.case,
    method: apiMethod?.get,
    methodname: 'getData',
  },
  postCaseData: {
    url: apiUrl?.case,
    method: apiMethod?.post,
    methodname: 'postData',
  },
  deleteCaseData: {
    url: apiUrl?.case,
    method: apiMethod?.delete,
    methodname: 'deleteData',
  },
  getUserRoleCount: {
    url: `${apiUrl?.general}User/Role/Count`,
    method: apiMethod?.get,
    methodname: 'getUserRoleCount',
  },
  getSearchBarData: {
    url: `${apiUrl?.case}/Search`,
    method: apiMethod?.post,
    methodname: 'getData Search Data',
  },
  getAttachments: {
    url: apiUrl?.case,
    method: apiMethod?.post,
    methodname: 'getAttachments',
  },
  postAttachmentData: {
    url: apiUrl?.case,
    method: apiMethod?.post,
    methodname: 'postAttachmentData',
  },
  getCasePrefixes: {
    url: `${apiUrl?.case}/GetCasePrefixes`,
    method: apiMethod?.post,
    methodname: 'getCasePrefixes',
  },
  getContractsForPrefix: {
    url: `${apiUrl?.general}Contracts`,
    method: apiMethod?.get,
    methodname: 'getContractsForPrefix',
  },
  casePrefix: {
    url: `${apiUrl?.case}/CasePrefix`,
    method: apiMethod?.get,
    methodname: 'casePrefix',
  },
  getCountryLookUpData: {
    url: `${apiUrl?.general}Country`,
    method: apiMethod?.get,
    methodname: 'getCountryLookUpData',
  },
  getTitleLookUpData: {
    url: `${apiUrl?.general}title`,
    method: apiMethod?.get,
    methodname: 'getTitleLookUpData',
  },
  getOrganisationData: {
    url: `${apiUrl?.general}GetOrganisations`,
    method: apiMethod?.post,
    methodname: 'get Organisation ',
  },
  editOrganisationData: {
    url: `${apiUrl?.general}Organisation`,
    method: apiMethod?.get,
    methodname: 'get Organisation by ID',
  },
  postOrganisationData: {
    url: `${apiUrl?.general}Organisation`,
    method: apiMethod?.post,
    methodname: 'Add Organisation',
  },
  putOrganisationData: {
    url: `${apiUrl?.general}Organisation`,
    method: apiMethod?.put,
    methodname: 'Update Organisation',
  },
  getContactAddress: {
    url: `${apiUrl?.general}ContactAddress/__contactId__/Contracts/__contractId__`,
    method: apiMethod?.get,
    methodname: 'Get ContactAddress List',
  },
  reRunVQ4: {
    url: `${apiUrl.general}ContactAddress/Contract/__contractId__/Case/__caseId__/UpdateRevertRequestForVQ4`,
    method: apiMethod.put,
    methodname: 'Re-Run VQ4',
  },
  putContactAddressKeeper: {
    url: `${apiUrl?.general}ContactAddress/Keeper/Contract/__contractId__`,
    method: 'put',
    methodname: 'ContactAddressKeeper',
  },
  putContactAddress: {
    url: `${apiUrl?.general}ContactAddress`,
    method: apiMethod?.put,
    methodname: 'Update ContactAddress',
  },
  deleteContactAddress: {
    url: `${apiUrl?.general}ContactAddress/__contactAddressId__/Contracts/__contractId__`,
    method: apiMethod?.delete,
    methodname: 'Delete ContactAddress',
  },
  getJobTypeForCase: {
    url: `${apiUrl?.general}EnforcementType/Case/__CaseId__/Contract/__ContractId__/JobEnforcementType`,
    method: apiMethod?.get,
    methodname: 'Getting job enforcement type',
  },
  Contract: {
    postGet: {
      url: `${apiUrl?.general}Contracts`,
      method: apiMethod?.post,
      methodname: 'GetContracts List',
    },
    post: {
      url: `${apiUrl?.general}Contract`,
      method: apiMethod?.post,
      methodname: 'PostContracts',
    },
    Get: {
      url: `${apiUrl?.general}Contract`,
      method: apiMethod?.get,
      methodname: 'GetContracts',
    },
    GetAllContracts: {
      url: `${apiUrl?.general}Contract/AllContracts`,
      method: apiMethod?.post,
      methodname: 'GetAllContracts',
    },
    JobSplitType: {
      url: `${apiUrl?.general}Contract/JobSplitType`,
      method: apiMethod?.get,
      methodname: 'GetJobSplitType',
    },
    postFaultName: {
      url: `${apiUrl?.general}FaultType`,
      method: apiMethod?.post,
      methodname: 'PostFaultType',
    },
    ContractsByOrganisation: {
      url: `${apiUrl?.general}ContractsByOrganisation`,
      method: apiMethod?.post,
      methodname: 'ContractsByOrganisation',
    },
    caseOverView: {
      url: `${apiUrl?.general}Contract/__contractId__/CaseOverview`,
      method: apiMethod?.get,
      methodname: 'caseOverView',
    },
    caseOverViewMetadata: {
      url: `${apiUrl?.general}Contract/__contractId__/CaseOverview/Metadata`,
      method: apiMethod?.get,
      methodname: 'caseOverViewMetadata',
    },
    taskOverView: {
      url: `${apiUrl?.general}Contract/Widget/TaskOverview/AllContract`,
      method: apiMethod?.get,
      methodname: 'taskOverView',
    },
    taskWidgetOverView: {
      url: `${apiUrl?.general}Contract/Widget/TaskOverview/TaskWidgetOverview?contractId=__contractId__`,
      method: apiMethod?.get,
      methodname: 'taskWidgetOverView',
    },
    paymentSummary: {
      url: `${apiUrl?.general}Contract/__contractId__/CasePaymentSummary?paymentSource=__paymentSource__`,
      method: apiMethod?.get,
      methodname: 'paymentSummary',
    },
    paymentSource: {
      url: `${apiUrl?.general}PaymentSource`,
      method: apiMethod?.get,
      methodname: 'paymentSource',
    },
    ActiveDaysRulesDetails: {
      url: `${apiUrl?.general}Contract/__contractId__/ActiveDaysRulesDetails`,
      method: apiMethod?.get,
      methodname: 'ActiveDaysRulesDetails',
    },
    ActiveDaysRulesPut: {
      url: `${apiUrl?.general}Contract/__contractId__/rule`,
      method: apiMethod?.put,
      methodname: 'ActiveDaysRulesDetails',
    },
    getContractType: {
      url: `${apiUrl?.general}contract/type`,
      method: apiMethod?.get,
      methodname: 'Contract type data',
    },
    getAutoAssign: {
      url: `${apiUrl?.general}ContractSetting/Contract/__ContractId__`,
      method: apiMethod?.get,
      methodname: 'getting details for auto assign',
    },
    postAutoAssign: {
      url: `${apiUrl?.general}ContractSetting`,
      method: apiMethod?.post,
      methodname: 'posting  auto assign changes',
    },
    getEmailAvailability: {
      url: `${apiUrl?.general}Contract/EmailAddress/__EmailAddress__/ClientId/__ClientId__/SecretId/__SecretId__/EmailCheckAvailability`,
      method: apiMethod?.get,
      methodname: 'Checking the availability of email Address',
    },
    getIllumin8Lookup: {
      url: `${apiUrl?.general}Contract/GetIllumin8Lookup`,
      method: apiMethod?.get,
      methodname: 'Getting Illumin8 Lookup Data',
    },
    getBatchPrintingFrequencyLookUpData: {
      url: `${apiUrl?.general}Frequency`,
      method: apiMethod?.get,
      methodname: 'Getting Batch Printing Frequency Lookup Data',
    },
  },
  DVLARequest: {
    getDataPostMethodVQ4: {
      url: `${apiUrl?.general}DVLA/Contract/__contractId__/GetVQ4Request`,
      method: apiMethod?.post,
      methodname: 'get V4 request method',
    },
    getDataPostMethodVQ5: {
      url: `${apiUrl?.general}DVLA/Contract/__contractId__/GetVQ5Response`,
      method: apiMethod?.post,
      methodname: 'get V5 request method',
    },
    getDataPostMethodProcessData: {
      url: `${apiUrl?.general}DVLA/Contract/__contractId__/GetProcess`,
      method: apiMethod?.post,
      methodname: 'Get Mismatched Data with PCN number',
    },
    putUpdateMethodProcessData: {
      url: `${apiUrl?.general}DVLA/Contract/__contractId__/DvlaProcess`,
      method: apiMethod?.put,
      methodname: 'Update Process Batch List Data',
    },
    dvlaDownloadEnquiryBatch: {
      url: `${apiUrl?.general}DVLA/GetVQ4RequestFile`,
      method: apiMethod?.post,
      methodname: 'dvlaDownloadEnquiryBatch',
    },
    dvlaDownloadResponseBatch: {
      url: `${apiUrl?.general}DVLA/GetVQ5ResponseFile`,
      method: apiMethod?.post,
      methodname: 'dvlaDownloadResponseBatch',
    },
    getDvlaAttachments: {
      url: `${apiUrl?.general}DVLA/Case/__caseId__/GetDVLAAttachments`,
      method: apiMethod?.get,
      methodname: 'getDvlaAttachments',
    },
    putVQ616Progress: {
      url: `${apiUrl?.general}DVLA/Contract/__contractId__/VQ616Progress`,
      method: apiMethod?.put,
      methodname: 'putVQ616Progress',
    },
    putVQ616CancelCase: {
      url: `${apiUrl?.general}DVLA/Contract/__contractId__/VQ616CancelCase`,
      method: apiMethod?.put,
      methodname: 'putVQ616CancelCase',
    },
    getReviewRequiredCases: {
      url: `${apiUrl?.general}DVLA/Contract/__contractId__/GetReviewRequiredCases`,
      method: apiMethod?.post,
      methodname: 'getReviewRequiredCases',
    },
  },
  payment: {
    refund: {
      url: `${apiUrl?.general}Payment/Refund`,
      method: apiMethod?.post,
      methodname: 'refund',
    },
    paymentReason: {
      url: `${apiUrl?.general}PaymentReason`,
      method: apiMethod?.get,
      methodname: 'paymentReason',
    },
    paymentMethod: {
      url: `${apiUrl?.general}PaymentMethod`,
      method: apiMethod?.post,
      methodname: 'paymentMethod',
    },
    chargeBack: {
      url: `${apiUrl?.general}Payment/ChargeBack`,
      method: apiMethod?.post,
      methodname: 'chargeBack',
    },
    chequeBounced: {
      url: `${apiUrl?.general}Payment/ChequeBounced`,
      method: apiMethod?.post,
      methodname: 'chequeBounced',
    },
    searchCase: {
      url: `${apiUrl?.general}Payment/Search`,
      method: apiMethod?.post,
      methodname: 'searchCase',
    },
    transfer: {
      url: `${apiUrl?.general}Payment/Transfer`,
      method: apiMethod?.post,
      methodname: 'transfer',
    },
    record: {
      url: `${apiUrl?.general}Payment/Record`,
      method: apiMethod?.post,
      methodname: 'record',
    },
    closeWithPartPayment: {
      url: `${apiUrl?.general}Payment/CloseWithPartPayment`,
      method: apiMethod?.put,
      methodname: 'closeWithPartPayment',
    },
    closeWithFullPayment: {
      url: `${apiUrl?.general}Payment/Contract/__ContractId__/Case/__CaseId__/CloseWithFullPayment`,
      method: apiMethod?.put,
      methodname: 'closeWithFullPayment',
    },
    partPaymentCaseList: {
      url: `${apiUrl?.general}Payment/Contract/__ContractId__/PartPaymentCaseList`,
      method: apiMethod?.post,
      methodname: 'PartPaymentCaseList',
    },
    updateCaseMarkAsPaid: {
      url: `${apiUrl?.general}Payment/Contract/__ContractId__/Case/__CaseId__/MarAsPaid`,
      method: apiMethod?.put,
      methodname: 'updateCaseMarkAsPaid',
    },
    partPaymentCaseListExport: {
      url: `${apiUrl?.general}Payment/Contract/__ContractId__/PartPaymentCaseListExport`,
      method: apiMethod?.get,
      methodname: 'partPaymentCaseListExport',
    },
  },
  paymentPlan: {
    addPaymentPlan: {
      url: `${apiUrl?.general}PaymentPlan/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'postTimePayPlan',
    },
    searchCaseNumber: {
      url: `${apiUrl?.general}PaymentPlan/Contract/__contractId__/SearchCaseNumber`,
      method: apiMethod?.post,
      methodname: 'searchCaseNumber',
    },
    getAllPaymentPlan: {
      url: `${apiUrl?.general}PaymentPlan/Contract/__contractId__/GetAllPaymentPlan`,
      method: apiMethod?.post,
      methodname: 'paymentPlanList',
    },
    cancelPaymentPlan: {
      url: `${apiUrl?.general}PaymentPlan/Contract/__contractId__/Reference/__referenceId__/CancelPaymentPlan`,
      method: apiMethod?.put,
      methodname: 'cancelPaymentPlan',
    },
    viewPaymentPlan: {
      url: `${apiUrl?.general}PaymentPlan/Contract/__contractId__/PaymentPlan/__id__/viewPaymentPlan`,
      method: apiMethod?.post,
      methodname: 'viewPaymentPlan',
    },
    downloadPaymentPlan: {
      url: `${apiUrl?.general}PaymentPlan/Contract/__contractId__/PaymentPlan/__id__/DownloadPaymentPlanDetails`,
      method: apiMethod?.get,
      methodname: 'downloadPaymentPlan',
    },
  },
  getRegionLookUpData: {
    url: `${apiUrl?.general}Region`,
    method: apiMethod?.get,
    methodname: 'getRegionLookUpData',
  },
  getTribunalLookUpData: {
    url: `${apiUrl?.general}Tribunal`,
    method: apiMethod?.get,
    methodname: 'getTribunalLookUpData',
  },
  getChargeRateLookUpData: {
    url: `${apiUrl?.general}ChargeRate/contract/__contractType__`,
    method: apiMethod?.get,
    methodname: 'getChargeRateLookUpData',
  },
  getReportingTypeLookUpData: {
    url: `${apiUrl?.general}ReportType`,
    method: apiMethod?.get,
    methodname: 'getReportingTypeLookUpData',
  },
  getFavouriteReportList: {
    url: `${apiUrl?.general}ReportFavourite/Contract/__contractId__/ReportDetails`,
    method: apiMethod?.get,
    methodname: 'getFavouriteReportList',
  },
  addFavouriteReport: {
    url: `${apiUrl?.general}ReportFavourite/Contract/__contractId__/WorkSpace/__WorkSpaceId__`,
    method: apiMethod?.post,
    methodname: 'addFavouriteReport',
  },
  removeFavouriteReport: {
    url: `${apiUrl?.general}ReportFavourite/Contract/__contractId__/WorkSpace/__WorkSpaceId__`,
    method: apiMethod?.delete,
    methodname: 'removeFavouriteReport',
  },
  getFaultTypeLookUpData: {
    url: `${apiUrl?.general}FaultType`,
    method: apiMethod?.get,
    methodname: 'getFaultTypeLookUpData',
  },
  getCCTVDoubleJeopardyRuleLookUpData: {
    url: `${apiUrl?.general}CCTVDoubleJeopardyRule`,
    method: 'get',
    methodname: 'getCCTVDoubleJeopardyRule',
  },
  getCountDataForHomeWidget: {
    url: `${apiUrl?.general}Contract/WidgetsCount`,
    method: apiMethod?.get,
    methodname: 'getCountDataForHomeWidget',
  },
  getContractForHomeWidget: {
    url: `${apiUrl?.general}Contract/Widgets`,
    method: apiMethod?.get,
    methodname: 'getContractForHomeWidget',
  },
  addFavouriteContract: {
    url: `${apiUrl?.general}Contract/__contractId__/Favourite`,
    method: apiMethod?.post,
    methodname: 'addFavouriteContract',
  },
  removeFavouriteContract: {
    url: `${apiUrl?.general}Contract/__contractId__/Favourite`,
    method: apiMethod?.delete,
    methodname: 'removeFavouriteContract',
  },
  representationReview: {
    representationReviewGetList: {
      url: `${apiUrl?.general}Workflow/__contractId__/ClientWorkflowTasks`,
      method: apiMethod?.post,
      methodname: 'get Formal stage case numbers',
    },
    representationReviewUpdate: {
      url: `${apiUrl?.general}Workflow/__contractId__/ClientWorkflowAcceptOrReject`,
      method: apiMethod?.put,
      methodname: 'update status of the case number',
    },
    chargeCertificateReviewGetList: {
      url: `${apiUrl?.general}Workflow/__contractId__/CCRepReviewCases`,
      method: apiMethod?.post,
      methodname: 'get Charge Certificate Review Tasks',
    },
    qaConfigurationGetList: {
      url: `${apiUrl?.general}Workflow/__ContractId__/QAConfigs`,
      method: apiMethod?.post,
      methodname: 'get QA Configuration Tasks',
    },
    qaConfigurationUpdate: {
      url: `${apiUrl?.general}Workflow/__ContractId__/User/__UserId__/QAConfig`,
      method: apiMethod?.put,
      methodname: 'update QA Configuration Tasks',
    },
  },
  getApprovalQueueListData: {
    url: `${apiUrl?.general}Correspondences`,
    method: apiMethod?.post,
    methodname: 'getData',
  },
  getCorrespondenceFileData: {
    url: `${apiUrl?.general}CorrespondencePreview`,
    method: apiMethod?.post,
    methodname: 'getData',
  },

  contraventionCodes: {
    postcontravention: {
      url: `${apiUrl?.general}Contract`,
      method: apiMethod?.post,
      methodname: 'Add Contravention',
    },
    getcontravention: {
      url: `${apiUrl?.general}ContraventionCode`,
      method: apiMethod?.get,
      methodname: 'Get Contravention',
    },
    putcontravention: {
      url: `${apiUrl?.general}Contract`,
      method: apiMethod?.put,
      methodname: 'Update Contravention',
    },
    deletecontravention: {
      url: `${apiUrl?.general}ContraventionCode`,
      method: apiMethod?.delete,
      methodname: 'Delete Contravention',
    },
    getcontraventionPath: {
      url: `${apiUrl?.general}ContraventionCode/ContraventionPath/ContractType`,
      method: apiMethod?.get,
      methodname: 'ContraventionPath lookup data',
    },
    getdifferentialLevel: {
      url: `${apiUrl?.general}DifferentialLevel`,
      method: apiMethod?.get,
      methodname: 'DifferentialLevel lookup data',
    },
    getdvlaEnquirycode: {
      url: `${apiUrl?.general}DVLAEnquiryCode`,
      method: apiMethod?.get,
      methodname: 'DVLAEnquiryCode lookup data',
    },
    getlocationGroup: {
      url: `${apiUrl?.general}LocationGroup`,
      method: apiMethod?.get,
      methodname: 'LocationGroup lookup data',
    },
    getContraventionCodes: {
      url: `${apiUrl?.general}Contract/__contractId__/contraventionCodes`,
      method: apiMethod?.get,
      methodname: 'LocationGroup lookup data',
    },
    contraventionUpload: {
      url: `${apiUrl?.general}ContraventionCode/Upload`,
      method: apiMethod?.post,
      methodname: 'PostContravention',
    },
    contraventionSampleDataDownload: {
      url: `${apiUrl?.general}template/Download`,
      method: apiMethod?.post,
      methodname: 'contraventionSampleDataDownload',
    },
    getContraventionErrorsExport: {
      url: `${apiUrl?.general}ContraventionCode/GetContraventionCodeErrorsExport`,
      method: apiMethod?.post,
      methodname: 'getContraventionErrorsExport',
    },
    getContraventionErrors: {
      url: `${apiUrl?.general}ContraventionCode/GetContraventionCodeErrors`,
      method: apiMethod?.post,
      methodname: 'GetContraventionErrors',
    },
    validationStatus: {
      url: `${apiUrl?.general}ContraventionCode/ValidationStatus`,
      method: apiMethod?.post,
      methodname: 'validationStatus',
    },
  },

  templates: {
    templateType: {
      url: `${apiUrl?.general}Template/Contract/_contractType_/ContractID/_contractId_/TemplateType`,
      method: apiMethod?.get,
      methodname: 'Template Type Data',
    },
    notificationType: {
      url: `${apiUrl?.general}Template/NotificationType`,
      method: apiMethod?.post,
      methodname: 'Notification Type Data',
    },
    templateLayoutTypes: {
      url: `${apiUrl?.general}LayoutType`,
      method: apiMethod?.get,
      methodname: 'Layout Type Data',
    },
    templateData: {
      url: `${apiUrl?.general}Templates`,
      method: apiMethod?.post,
      methodname: 'Template Data',
    },
    headerFooterList: {
      url: `${apiUrl?.general}Template/HeaderOrFooterList`,
      method: apiMethod?.post,
      methodname: 'Header Footer List Data',
    },
    hhdNoticeTemplateList: {
      url: `${apiUrl?.general}HHDTemplates`,
      method: apiMethod?.post,
      methodname: 'HHD notice template list data',
    },
    statDocType: {
      url: `${apiUrl?.general}Template/Contract/_contractType_/PrintBatchType`,
      method: apiMethod?.get,
      methodname: 'StatDocType',
    },
    reminderLetterList: {
      url: `${apiUrl?.general}Template/ReminderLetters`,
      method: apiMethod?.get,
      methodname: 'reminderLetter',
    },
    witnessStatementType: {
      url: `${apiUrl?.general}Template/WitnessStatementType`,
      method: apiMethod?.get,
      methodname: 'witnessStatementType',
    },
    splitPrintType: {
      url: `${apiUrl?.general}Template/SplitPrintType`,
      method: apiMethod?.get,
      methodname: 'splitPrintType',
    },
    post: {
      HeaderFooterTemplate: {
        url: `${apiUrl?.general}Template/HeaderOrFooter`,
        method: apiMethod?.post,
        methodname: 'HeaderFooterTemplate Data',
      },
      Template: {
        url: `${apiUrl?.general}Template`,
        method: apiMethod?.post,
        methodname: 'Template Data',
      },
      hhdNoticeTemplate: {
        url: `${apiUrl?.general}HHDTemplate`,
        method: apiMethod?.post,
        methodname: 'HHD notice template Data Insert',
      },
    },
    delete: {
      HeaderFooterTemplate: {
        url: `${apiUrl?.general}Template/HeaderOrFooter`,
        method: apiMethod?.delete,
        methodname: 'HeaderFooterTemplate Data',
      },
      Template: {
        url: `${apiUrl?.general}Template`,
        method: apiMethod?.delete,
        methodname: 'Template Data',
      },
    },
    preview: {
      PreviewHeaderOrFooter: {
        url: `${apiUrl?.general}Template/PreviewHeaderOrFooter`,
        method: apiMethod?.get,
        methodname: 'PreviewHeaderOrFooter Data',
      },
      PreviewContent: {
        url: `${apiUrl?.general}Preview`,
        method: apiMethod?.get,
        methodname: 'PreviewContent',
      },
      TemplatePreviewContent: {
        url: `${apiUrl?.general}Template/PreviewContent`,
        method: apiMethod?.get,
        methodname: 'TemplatePreviewContent',
      },
      HhdNoticeTemplate: {
        url: `${apiUrl?.general}Template/PreviewContent/__templateId__`,
        method: apiMethod?.get,
        methodname: 'Preview Hhd Notice Template',
      },
      PreviewEditContent: {
        url: `${apiUrl?.general}Template/PreviewContent`,
        method: apiMethod?.get,
        methodname: 'PreviewContent',
      },
      ApprovalQueueTemplatePreview: {
        url: `${apiUrl?.general}Template/Contract/__contractId__/ApprovalQueueTemplatePreview`,
        method: apiMethod?.post,
        methodname: 'ApprovalQueueTemplatePreview',
      },
    },
    GetById: {
      HeaderOrFooter: {
        url: `${apiUrl?.general}Template/HeaderOrFooter`,
        method: apiMethod?.get,
        methodname: 'HeaderOrFooter Data',
      },
      Template: {
        url: `${apiUrl?.general}Template`,
        method: apiMethod?.get,
        methodname: 'Template',
      },
    },
    put: {
      HeaderFooter: {
        url: `${apiUrl?.general}Template/HeaderOrFooter`,
        method: apiMethod?.put,
        methodname: 'HeaderFooter Template Data',
      },
      Template: {
        url: `${apiUrl?.general}Template`,
        method: apiMethod?.put,
        methodname: 'Template Data',
      },
      hhdNoticeTemplate: {
        url: `${apiUrl?.general}HHDTemplate`,
        method: apiMethod?.post,
        methodname: 'HHD notice template Data Insert',
      },
    },
    ContractPermissionTypes: {
      url: `${apiUrl?.general}Permission/Contract/__contractId__/ContractPermissionTypes`,
      method: apiMethod?.get,
      methodname: 'ContractPermissionTypes',
    },
    getSenderEmailID: {
      url: `${apiUrl?.general}Contract/__contractId__/PermissionType/__id__/SenderEmail`,
      method: apiMethod?.get,
      methodname: 'getSenderEmailID',
    },
    getMergeFieldList: {
      url: `${apiUrl?.general}Template/Contract/__contractId__/MergeFields`,
      method: apiMethod?.get,
      methodname: 'getMergeFieldList',
    },
  },
  userFlow: {
    url: `${apiUrl?.general}Login/UserFlow`,
    method: apiMethod?.post,
    methodname: 'userFlow',
  },

  userPermissionCheck: {
    url: `${apiUrl?.general}login`,
    method: apiMethod?.get,
    methodname: 'userPermissionCheck',
  },
  Currency: {
    getAll: {
      url: `${apiUrl?.general}Currency`,
      method: apiMethod?.get,
      methodname: 'GetCurrency',
    },
  },
  FAQ: {
    getAll: {
      url: `${apiUrl?.general}ChallengeFAQs`,
      method: apiMethod?.post,
      methodname: 'GetFaq',
    },
    post: {
      url: `${apiUrl?.general}ChallengeFAQ`,
      method: apiMethod?.post,
      methodname: 'PostFaq',
    },
    put: {
      url: `${apiUrl?.general}ChallengeFAQ`,
      method: apiMethod?.put,
      methodname: 'PutFaq',
    },
    GetById: {
      url: `${apiUrl?.general}ChallengeFAQ`,
      method: apiMethod?.get,
      methodname: 'GetFaq',
    },
    delete: {
      url: `${apiUrl?.general}ChallengeFAQ`,
      method: apiMethod?.delete,
      methodname: 'deleteFaq',
    },
    upload: {
      url: `${apiUrl?.general}ChallengeFAQ/Upload`,
      method: apiMethod?.post,
      methodname: 'PostFaq',
    },
    faqSampleDataDownload: {
      url: `${apiUrl?.general}template/Download`,
      method: apiMethod?.post,
      methodname: 'faqSampleDataDownload',
    },
    getFAQErrorsExport: {
      url: `${apiUrl?.general}ChallengeFAQ/GetFAQErrorsExport`,
      method: apiMethod?.post,
      methodname: 'getFAQErrorsExport',
    },
    getFAQErrors: {
      url: `${apiUrl?.general}ChallengeFAQ/GetFAQErrors`,
      method: apiMethod?.post,
      methodname: 'GetFAQErrors',
    },
    validationStatus: {
      url: `${apiUrl?.general}ChallengeFAQ/validationStatus`,
      method: apiMethod?.post,
      methodname: 'validationStatus',
    },
  },
  Users: {
    gtUser: {
      url: `${apiUrl?.general}Users `,
      method: apiMethod?.post,
      methodname: 'Get User data',
    },
    createUser: {
      url: `${apiUrl?.general}BackOffice/CreateUser`,
      method: apiMethod?.post,
      methodname: 'createUser',
    },
    updateUser: {
      url: `${apiUrl?.general}BackOffice/UpdateUser`,
      method: apiMethod?.put,
      methodname: 'updateUser',
    },
    getUserById: {
      url: `${apiUrl?.general}BackOffice/User`,
      method: apiMethod?.get,
      methodname: 'gettingUserById',
    },

    getRoles: {
      url: `${apiUrl?.general}UserRoles`,
      method: apiMethod?.get,
      methodname: 'Get all available roles',
    },
    poundLocation: {
      url: `${apiUrl?.general}ClampAndRemoval/PoundLocation/Contract/_contractId_`,
      method: apiMethod?.get,
      methodname: 'Getting pound location data',
    },
    poundOpOrManagerLocation: {
      url: `${apiUrl?.general}Pound/Contract/_contractId_/Locations`,
      method: apiMethod?.get,
      methodname: 'Getting pound location data operator or manager',
    },
    exportUsers: {
      url: `${apiUrl?.general}User/UserDetailsExport`,
      method: apiMethod?.get,
      methodname: 'Export Users',
    },
    deleteUser: {
      url: `${apiUrl?.general}User/_userId_`,
      method: apiMethod?.delete,
      methodname: 'Delete User',
    },
  },
  Correspondence: {
    getTemplate: {
      url: `${apiUrl?.general}Template/TemplateList`,
      method: apiMethod?.post,
      methodname: 'Get Templates data',
    },
    getContactAddress: {
      url: `${apiUrl?.case}/__caseId__/GetContactAddress`,
      method: apiMethod?.post,
      methodname: 'ContactAddress',
    },
    getTemplatePreview: {
      url: `${apiUrl?.general}Preview`,
      method: apiMethod?.get,
      methodname: 'Template Preview',
    },
    postSendCorrespondence: {
      url: `${apiUrl?.general}Correspondence`,
      method: apiMethod?.post,
      methodname: 'Correspondence',
    },
    getcorrespondencePreview: {
      url: `${apiUrl?.general}CorrespondencePreview`,
      method: apiMethod?.get,
      methodname: 'CorrespondencePreview',
    },
    postCorrespondenceApprove: {
      url: `${apiUrl?.general}CorrespondenceApprove`,
      method: apiMethod?.post,
      methodname: 'CorrespondenceApprove',
    },
    convertDocxtopdf: {
      url: `${apiUrl?.general}template/convertdocxtopdf`,
      method: apiMethod?.post,
      methodname: 'convertDocxtopdf',
    },
    getCaseAttachments: {
      url: `${apiUrl?.general}Template/Contract/__ContractId__/Case/__CaseId__/GetAttachmentListByCase`,
      method: apiMethod?.get,
      methodname: 'Getting Case Attachments',
    },
    updateCorrespondenceTemplate: {
      url: `${apiUrl?.general}Template/Contract/__ContractId__/UpdateCorrespondenceTemplatePreview`,
      method: apiMethod?.post,
      methodname: 'Update Correspondence Preview',
    },
    updateFrequentlyUsedCount: {
      url: `${apiUrl?.general}Correspondence/Reason/contract/__contractId__/UpdateFrequentlyUsedCount`,
      method: apiMethod?.put,
      methodname: 'Update Frequently Used Count',
    },
    getCorrespondenceDetail: {
      url: `${apiUrl?.general}CorrespondenceDetail/__correspondenceId__/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'CorrespondenceDetail',
    },
  },
  casePayment: {
    getCasePaymentData: {
      url: `${apiUrl?.case}/__caseId__/Payments `,
      method: apiMethod?.get,
      methodname: 'GetCasePaymentData',
    },
    getPaymentDueAmount: {
      url: `${apiUrl?.case}/__caseId__/GetPaymentDueAmount`,
      method: apiMethod?.get,
      methodname: 'getPaymentDueAmount',
    },
    getPaymentInvoiceDetail: {
      url: `${apiUrl?.case}/__caseId__/GetPaymentInvoiceDetails `,
      method: apiMethod?.post,
      methodname: 'getPaymentInvoiceDetail',
    },
    removePayments: {
      url: `${apiUrl?.general}Payment/RemovePayment`,
      method: apiMethod?.post,
      methodname: 'removePayments',
    },
    getManualDiscounts: {
      url: `${apiUrl?.general}Payment/Case/__caseId__/GetManualDiscounts `,
      method: apiMethod?.post,
      methodname: 'getManualDiscounts',
    },
    manualDiscount: {
      url: `${apiUrl?.general}Payment/Case/__caseId__/ManualDiscount `,
      method: apiMethod?.post,
      methodname: 'manualDiscount',
    },
    deleteManualDiscount: {
      url: `${apiUrl?.general}Payment/ManualDiscount/__manualDiscountId__`,
      method: apiMethod?.delete,
      methodname: 'deleteManualDiscount',
    },
    getManageCosts: {
      url: `${apiUrl?.general}Payment/Case/__caseId__/ManageCostDetails `,
      method: apiMethod?.get,
      methodname: 'getManageCosts',
    },
    manageCost: {
      url: `${apiUrl?.general}Payment/ManageCost `,
      method: apiMethod?.post,
      methodname: 'manageCost',
    },
    deleteManageCost: {
      url: `${apiUrl?.general}Payment/AppealCostId/__appealCostId__/ManageCost`,
      method: apiMethod?.delete,
      methodname: 'deleteManageCost',
    },
  },
  stage: {
    get: {
      url: `${apiUrl?.general}Stage`,
      method: apiMethod?.get,
      methodname: 'GetStage',
    },
  },
  status: {
    get: {
      url: `${apiUrl?.general}Status`,
      method: apiMethod?.get,
      methodname: 'GetStatus',
    },
  },
  updateStageStatus: {
    url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/CancelReason/__cancelReasonId__/UpdateStageAndStatus`,
    method: apiMethod?.put,
    methodname: 'updateStageStatus',
  },
  vehicleRemoved: {
    url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/VehicleRemoved`,
    method: apiMethod?.put,
    methodname: 'vehicleRemoved',
  },
  stageAndStatus: {
    listOfStages: {
      url: `${apiUrl?.case}/Contract/__contractId__/ManualCaseStage`,
      method: apiMethod?.post,
      methodname: 'listOfStages',
    },
    listOfStatusForStage: {
      url: `${apiUrl?.case}/Contract/__contractId__/Stage/__stageName__/ManualCaseStatus`,
      method: apiMethod?.get,
      methodname: 'listOfStatusForStage',
    },
  },
  UpdateTPTVerificationCode: {
    url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/UpdateTPTVerificationCode`,
    method: apiMethod?.put,
    methodname: 'UpdateTPTVerificationCode',
  },

  Workflow: {
    UnassignedTasks: {
      url: `${apiUrl?.general}Workflow/__contractId__/UnassignedTasks`,
      method: apiMethod?.post,
      methodname: 'UnassignedTasks',
    },
    AssignedTasks: {
      url: `${apiUrl?.general}Workflow/__contractId__/AssignedTasks`,
      method: apiMethod?.post,
      methodname: 'AssignedTasks',
    },
    UnassignedHierarchyView: {
      url: `${apiUrl?.general}Workflow/__contractId__/UnassignedHierarchyView`,
      method: apiMethod?.get,
      methodname: 'UnassignedHierarchyView',
    },
    AssignedHierarchyView: {
      url: `${apiUrl?.general}Workflow/__contractId__/AssignedHierarchyView`,
      method: apiMethod?.get,
      methodname: 'AssignedHierarchyView',
    },
    WorkflowManagerBOUsers: {
      url: `${apiUrl?.general}Workflow/__contractId__/WorkflowManagerBOUsers`,
      method: apiMethod?.get,
      methodname: 'WorkflowManagerBOUsers',
    },
    UnassignOrAssign: {
      url: `${apiUrl?.general}Workflow/__contractId__/UnassignOrAssign`,
      method: apiMethod?.put,
      methodname: 'UnassignOrAssign',
    },
    Reassign: {
      url: `${apiUrl?.general}Workflow/__contractId__/Reassign`,
      method: apiMethod?.put,
      methodname: 'Reassign',
    },
    Complete: {
      url: `${apiUrl?.general}Workflow/__contractId__/Complete`,
      method: apiMethod?.put,
      methodname: 'Complete',
    },
    MyWorkflowBOUsers: {
      url: `${apiUrl?.general}Workflow/__contractId__/MyWorkflowBOUsers`,
      method: apiMethod?.get,
      methodname: 'MyWorkflowBOUsers',
    },
    MyWorkflows: {
      url: `${apiUrl?.general}Workflow/__contractId__/MyWorkflows`,
      method: apiMethod?.post,
      methodname: 'MyWorkflows',
    },
    OnHoldTasks: {
      url: `${apiUrl?.general}Workflow/OnHoldTasks`,
      method: apiMethod?.post,
      methodname: 'OnHoldTasks',
    },
    UpdateOnHoldStatus: {
      url: `${apiUrl?.general}Workflow/OnHoldTasks`,
      method: apiMethod?.put,
      methodname: 'UpdateOnHoldStatus',
    },
    AbandonStatus: {
      url: `${apiUrl?.general}Workflow/__contractId__/Workflow/__workflowId__/AbandonStatus`,
      method: apiMethod?.put,
      methodname: 'AbandonStatus',
    },
    associatedCases: {
      url: `${apiUrl?.general}Workflow/Contract/__contractId__/WorkflowAssociatedCases`,
      method: apiMethod?.post,
      methodname: 'Case associated Validation',
    },
    delete: {
      url: `${apiUrl?.general}Workflow/Contract/__contractId__/DeleteUnassignedTask`,
      method: apiMethod?.delete,
      methodname: 'DeleteWorkflow',
    },
    caseNumberAssignToUnassignedTask: {
      url: `${apiUrl?.general}Workflow/Contract/__contractId__/CaseNumberAssignToUnassignedTask`,
      method: apiMethod?.put,
      methodname: 'caseNumberAssignToUnassignedTask',
    },
    ocrErrorAttachments: {
      url: `${apiUrl?.general}Workflow/__workflowId__/Contract/__contractId__/OCRErrorAttachments`,
      method: apiMethod?.get,
      methodname: 'ocrErrorAttachments',
    },
    searchColumns: {
      url: `${apiUrl?.general}Workflow/Contract/__ContractId__/SearchColumns`,
      method: apiMethod?.get,
      methodname: 'searchColumns',
    },
    CaseOpenWorkflowDetail: {
      url: `${apiUrl?.general}Workflow/Case/__CaseId__/CaseOpenWorkflowDetail`,
      method: apiMethod?.get,
      methodname: 'caseOpenWorkflowDetail',
    },
    AutoComplete: {
      url: `${apiUrl?.general}Workflow/Contract/__ContractId__/AutoComplete`,
      method: apiMethod?.put,
      methodname: 'autoComplete',
    },
    CompleteRejectPL: {
      url: `${apiUrl?.general}Workflow/__contractId__/Workflow/CompleteRejectPL`,
      method: apiMethod?.put,
      methodname: 'CompleteRejectPL',
    },
  },
  TribunalAppeals: {
    TribunalAppealsPost: {
      url: apiUrl?.case,
      method: apiMethod?.post,
      methodname: 'PostTribunalAppeal',
    },
    TribunalAppealsPut: {
      url: apiUrl?.case,
      method: apiMethod?.put,
      methodname: 'PutTribunalAppeals',
    },
    TribunalAppealGet: {
      url: `${apiUrl?.case}/TribunalAppeal`,
      method: apiMethod?.get,
      methodname: 'getTribunalAppeals',
    },
    TribunalAppealsDelete: {
      url: `${apiUrl?.case}/TribunalAppeal`,
      method: apiMethod?.delete,
      methodname: 'deleteTribunalAppeals',
    },
    GetHearingType: {
      url: `${apiUrl?.general}HearingType`,
      method: apiMethod?.get,
      methodname: 'getHearingType',
    },
  },
  Notification: {
    getNotification: {
      url: `${apiUrl?.general}Notification`,
      method: apiMethod?.get,
      methodname: 'Notification',
    },
    putNotification: {
      url: `${apiUrl?.general}Notification`,
      method: apiMethod?.put,
      methodname: 'Notification',
    },
    putTaskNotification: {
      url: `${apiUrl?.general}Notification/__notificationId__/Contract/__contractId__/StatusUpdate`,
      method: apiMethod?.put,
      methodname: 'TaskNotification',
    },
    getMessages: {
      url: `${apiUrl?.general}Notification/Contract/__contractId__/Messages`,
      method: apiMethod?.post,
      methodname: 'Messages',
    },
    getUsers: {
      url: `${apiUrl?.general}Notification/Contract/__contractId__/CEOUsers`,
      method: apiMethod?.get,
      methodname: 'CEOUsers',
    },
    getLocations: {
      url: `${apiUrl?.general}Notification/Contract/__contractId__/Locations`,
      method: apiMethod?.get,
      methodname: 'Locations',
    },
    postNotification: {
      url: `${apiUrl?.general}Notification/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'Notification',
    },
    getBOUsers: {
      url: `${apiUrl?.general}Notification/Contract/__contractId__/BOUsers`,
      method: apiMethod?.get,
      methodname: 'BOUsers',
    },
    getVRMNumbers: {
      url: `${apiUrl?.general}Notification/Contract/__contractId__/VRMNumbers`,
      method: apiMethod?.get,
      methodname: 'getVRMNumbers',
    },
    getContraventionCodes: {
      url: `${apiUrl?.general}/Contract/__contractId__/ContraventionCodes`,
      method: apiMethod?.get,
      methodname: 'getContraventionCodes',
    },
    getMessage: {
      url: `${apiUrl?.general}Notification/Contract/__contractId__/Message/__ReferenceId__`,
      method: apiMethod?.get,
      methodname: 'getMessage',
    },
    deleteMessage: {
      url: `${apiUrl?.general}Notification/Message/__ReferenceId__`,
      method: apiMethod?.delete,
      methodname: 'deleteMessage',
    },
    updateMessage: {
      url: `${apiUrl?.general}Notification/OnStreetMessage`,
      method: apiMethod?.put,
      methodname: 'updateMessage',
    },
  },
  Zone: {
    getZones: {
      url: `${apiUrl?.general}Zones`,
      method: apiMethod?.post,
      methodname: 'Zones',
    },
    getZone: {
      url: `${apiUrl?.general}Zone`,
      method: apiMethod?.get,
      methodname: 'Zone',
    },
    postZone: {
      url: `${apiUrl?.general}Zone`,
      method: apiMethod?.post,
      methodname: 'Zone',
    },
    putZone: {
      url: `${apiUrl?.general}Zone`,
      method: apiMethod?.put,
      methodname: 'Zone',
    },
    deleteZone: {
      url: `${apiUrl?.general}Zone`,
      method: apiMethod?.delete,
      methodname: 'Zone',
    },
    zoneSampleDataDownload: {
      url: `${apiUrl?.general}Template/Download`,
      method: apiMethod?.post,
      methodname: 'sampleDownload',
    },
    zoneUpload: {
      url: `${apiUrl?.general}Zone/Upload`,
      method: apiMethod?.post,
      methodname: 'Zone',
    },
    uploadedFileErrorsExport: {
      url: `${apiUrl?.general}Zone/UploadedFileErrorsExport`,
      method: apiMethod?.post,
      methodname: 'uploadedFileErrorsExport',
    },
    getZoneErrors: {
      url: `${apiUrl?.general}Zone/UploadedFileErrors`,
      method: apiMethod?.post,
      methodname: 'UploadedFileErrors',
    },
    validationStatus: {
      url: `${apiUrl?.general}Zone/BulkUploadStatus`,
      method: apiMethod?.post,
      methodname: 'UploadedFileErrors',
    },
    exportZone: {
      url: `${apiUrl?.general}Zone/Export`,
      method: apiMethod?.get,
      methodname: 'Export Zone',
    },
  },
  cancelReason: {
    url: `${apiUrl?.general}CancelReason/Contract/__contractId__`,
    method: apiMethod?.get,
    methodname: 'cancelReason',
  },
  cancellationReason: {
    getCancelReason: {
      url: `${apiUrl?.general}GetCancelReasons`,
      method: apiMethod?.post,
      methodname: 'cancelReason',
    },
    postCancelReason: {
      url: `${apiUrl?.general}CancelReason`,
      method: apiMethod?.post,
      methodname: 'cancelReason',
    },
    deleteCancelReason: {
      url: `${apiUrl?.general}CancelReason`,
      method: apiMethod?.delete,
      methodname: 'cancelReason',
    },
    exportCancelReason: {
      url: `${apiUrl?.general}CancelReason/Export`,
      method: apiMethod?.get,
      methodname: 'Export cancelReason',
    },
    cancelReasonValidationAssociated: {
      url: `${apiUrl?.general}CancelReason/__caseId__/Contract/__contractId__/Reference`,
      method: apiMethod?.get,
      methodname: 'Associated validation',
    },
    upload: {
      url: `${apiUrl?.general}CancelReason/Upload`,
      method: apiMethod?.post,
      methodname: 'Postupload',
    },
    cancellationReasonSampleDataDownload: {
      url: `${apiUrl?.general}template/Download`,
      method: apiMethod?.post,
      methodname: 'cancellationReasonSampleDataDownload',
    },
    getCancellationReasonErrorsExport: {
      url: `${apiUrl?.general}CancelReason/GetCancelReasonErrorsExport`,
      method: apiMethod?.post,
      methodname: 'getCancellationReasonErrorsExport',
    },
    getCancellationReasonErrors: {
      url: `${apiUrl?.general}CancelReason/GetCancelReasonErrors`,
      method: apiMethod?.post,
      methodname: 'getCancellationReasonErrors',
    },
    validationStatus: {
      url: `${apiUrl?.general}CancelReason/validationStatus`,
      method: apiMethod?.post,
      methodname: 'validationStatus',
    },
  },
  // Reject Reason endpoints
  rejectReason: {
    getRejectReason: {
      url: `${apiUrl?.general}GetRejectReasons`,
      method: apiMethod?.post,
      methodname: 'rejectReason',
    },
    postRejectReason: {
      url: `${apiUrl?.general}RejectReason`,
      method: apiMethod?.post,
      methodname: 'rejectReason',
    },
    deleteRejectReason: {
      url: `${apiUrl?.general}RejectReason`,
      method: apiMethod?.delete,
      methodname: 'rejectReason',
    },
    exportRejectReason: {
      url: `${apiUrl?.general}RejectReason/Export`,
      method: apiMethod?.get,
      methodname: 'Export rejectReason',
    },
    upload: {
      url: `${apiUrl?.general}RejectReason/Upload`,
      method: apiMethod?.post,
      methodname: 'Postupload',
    },
    rejectReasonSampleDataDownload: {
      url: `${apiUrl?.general}template/Download`,
      method: apiMethod?.post,
      methodname: 'rejectReasonSampleDataDownload',
    },
    getRejectReasonErrorsExport: {
      url: `${apiUrl?.general}RejectReason/GetRejectReasonErrorsExport`,
      method: apiMethod?.post,
      methodname: 'getRejectReasonErrorsExport',
    },
    getRejectReasonErrors: {
      url: `${apiUrl?.general}RejectReason/GetRejectReasonErrors`,
      method: apiMethod?.post,
      methodname: 'getRejectReasonErrors',
    },
    validationStatus: {
      url: `${apiUrl?.general}RejectReason/validationStatus`,
      method: apiMethod?.post,
      methodname: 'validationStatus',
    },
    getRejectReasonsByContract: {
      url: `${apiUrl?.general}RejectReason/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'getRejectReasonsByContract',
    },
  },
  holdReason: {
    getHoldReasons: {
      url: `${apiUrl?.general}HoldReasons`,
      method: apiMethod?.post,
      methodname: 'holdReason',
    },
    postHoldReason: {
      url: `${apiUrl?.general}HoldReason`,
      method: apiMethod?.post,
      methodname: 'holdReason',
    },
    putHoldReason: {
      url: `${apiUrl?.general}HoldReason/__id__`,
      method: apiMethod?.post,
      methodname: 'holdReason',
    },
    deleteHoldReason: {
      url: `${apiUrl?.general}HoldReason`,
      method: apiMethod?.delete,
      methodname: 'holdReason',
    },
    exportHoldReasons: {
      url: `${apiUrl?.general}HoldReason/Export`,
      method: apiMethod?.get,
      methodname: 'Export holdReason',
    },
  },
  case: {
    cancel: {
      url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/Cancel`,
      method: 'Patch',
      methodname: 'cancelCase',
    },
    updateCaseServiceType: {
      url: `${apiUrl?.case}/__caseId__/ServiceType/__serviceTypeId__/Contract/__contractId__/UpdateCaseServiceType`,
      method: 'PUT',
      methodname: 'Update Case ServiceType',
    },
  },

  caseProgression: {
    reversal: {
      url: `${apiUrl?.general}CaseProgression/Contract/__contractId__/revert`,
      method: 'Patch',
      methodname: 'reversal',
    },
    revertIssued: {
      url: `${apiUrl?.general}CaseProgression/Contract/__contractId__/revert`,
      method: 'Patch',
      methodname: 'revert Issued',
    },
    stageStatusSettings: {
      url: `${apiUrl?.general}CaseProgression/StageAndStatus/Contract/__contractId__`,
      method: 'Patch',
      methodname: 'stageStatusSettings',
    },
    tribunalAppealAllowed: {
      url: `${apiUrl?.general}Case/__caseId__/CancelReason/__CancelReasonId__/Contract/__contractId__/TribunalAppealAllowed`,
      method: apiMethod?.put,
      methodname: 'TribunalAppealAllowed',
    },
    tribunalAppealReject: {
      url: `${apiUrl?.general}Case/__caseId__/Contract/__contractId__/TribunalAppealReject`,
      method: apiMethod?.put,
      methodname: 'TribunalAppealReject',
    },
    tribunalAppealWithdrawn: {
      url: `${apiUrl?.general}Case/__caseId__/Contract/__contractId__/AppealWithdrawn`,
      method: apiMethod?.put,
      methodname: 'AppealWithdrawn',
    },
    tribunalAppealWitness: {
      url: `${apiUrl?.general}Case/__caseId__/Contract/__contractId__/TribunalAppealWitness`,
      method: apiMethod?.put,
      methodname: 'TribunalAppealWitness',
    },
    noaWarningNotice: {
      url: `${apiUrl?.general}CaseProgression/Contract/__contractId__/__contractType__/WarningNoticeRevert`,
      method: apiMethod?.patch,
      methodname: 'NOAWarningNotice',
    },
    discountCCRepReject: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/DiscountCCRepReject?IsCreateCorrespondence=__isCreateCorrespondence__`,
      method: apiMethod?.patch,
      methodname: 'DiscountCCRepReject',
    },
    discountOFRRepReject: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/DiscountOFRRepReject?IsCreateCorrespondence=__isCreateCorrespondence__`,
      method: apiMethod?.patch,
      methodname: 'discountOFRRepReject',
    },
    discountPreNTORepReject: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/DiscountPreNtOChallengeReject?IsCreateCorrespondence=__isCreateCorrespondence__`,
      method: apiMethod?.patch,
      methodname: 'discountPreNTORepReject',
    },
    discountRepReject: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/DiscountRepReject?IsCreateCorrespondence=__isCreateCorrespondence__`,
      method: apiMethod?.patch,
      methodname: 'discountRepReject',
    },
    actioned: {
      url: `${apiUrl?.general}CaseProgression/Contract/__contractId__/Action`,
      method: apiMethod?.patch,
      methodname: 'actioned',
    },
    dayLetterReverted: {
      url: `${apiUrl?.general}CaseProgression/Contract/__contractId__/DayLetterRevert`,
      method: apiMethod?.patch,
      methodname: 'dayLetterReverted',
    },
    reClosefollowingPaidCorrespondence: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/ReClosefollowingPaidCorrespondence?IsCreateCorrespondence=__isCreateCorrespondence__`,
      method: apiMethod?.patch,
      methodname: 'ReClosefollowingPaidCorrespondence',
    },

    challengeAction: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/ChallengeAction`,
      method: apiMethod?.patch,
      methodname: 'ChallengeAction',
    },
    acceptTolRepatOFR: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/IsCreateCorrespondence/__isCreateCorrespondence__/AcceptTolRepatOFR`,
      method: apiMethod?.patch,
      methodname: 'AcceptTolRepatOFR',
    },
    revertToIssuedDiscount: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/DiscountRevertToIssued`,
      method: apiMethod?.patch,
      methodname: 'RevertToIssuedDiscount',
    },
    revertToIssuedDiscountPL: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/RevertToPLDiscount`,
      method: apiMethod?.patch,
      methodname: 'RevertToPLDiscount',
    },
    courtPackDownload: {
      url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/DownloadCourtPack`,
      method: apiMethod?.get,
      methodname: 'downloadCourtPack',
    },
    // adding query params for - Bug 200257: Total days count get increased when stage and status OFR /discount and charge certificate /discount cases in approval queue
    reversedCancellation: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/ReversedCancellation?IsCreateCorrespondence=__isCreateCorrespondence__`,
      method: apiMethod?.patch,
      methodname: 'ReversedCancellation',
    },
    challengeRequest: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/ChallengeRequest?IsCreateCorrespondence=__isCreateCorrespondence__&InformalInfoSendDate=__informalInfoSendDate__`,
      method: apiMethod?.patch,
      methodname: 'ChallengeRequest',
    },
    revertToFullChargeAtCC: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/RevertToFullChargeAtCC?IsCreateCorrespondence=__isCreateCorrespondence__`,
      method: apiMethod?.patch,
      methodname: 'RevertToFullChargeAtCC',
    },
    revertToDiscountAtCC: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/RevertToDiscountAtCC`,
      method: apiMethod?.patch,
      methodname: 'RevertToDiscountAtCC',
    },
    discountRepReject21Days: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/DiscountRepReject21Days?IsCreateCorrespondence=__isCreateCorrespondence__`,
      method: apiMethod?.patch,
      methodname: 'DiscountRepReject21Days',
    },
    revertToSelectForNIP: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/RevertToSelectForNIP`,
      method: apiMethod?.patch,
      methodname: 'RevertToSelectForNIP',
    },
    revertToNIPSent: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/RevertToNIPSent`,
      method: apiMethod?.patch,
      methodname: 'RevertToNIPSent',
    },
    revertToSelectForNIPFinalWarning: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/RevertToSelectForNIPFinalWarning`,
      method: apiMethod?.patch,
      methodname: 'RevertToSelectForNIPFinalWarning',
    },
    revertToNIPFinalWarningSent: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/RevertToNIPFinalWarningSent`,
      method: apiMethod?.patch,
      methodname: 'RevertToNIPFinalWarningSent',
    },
    revertToSelectForChargeCert: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/RevertToSelectForCC`,
      method: apiMethod?.patch,
      methodname: 'RevertToSelectForChargeCert',
    },
    revertToPostChargeCert: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/RevertToPostCC`,
      method: apiMethod?.patch,
      methodname: 'RevertToPostChargeCert',
    },
    plRevertToIssued: {
      url: `${apiUrl?.general}/CaseProgression/Case/__caseId__/Contract/__contractId__/PLRevertToIssued`,
      method: apiMethod?.patch,
      methodname: 'PLRevertToIssued',
    },
    plRevertToSelectForFinalWarning: {
      url: `${apiUrl?.general}/CaseProgression/Case/__caseId__/Contract/__contractId__/PLRevertToSelectForFinalWarning`,
      method: apiMethod?.patch,
      methodname: 'PLRevertToSelectForFinalWarning',
    },
    plRevertToFinalWarningSent: {
      url: `${apiUrl?.general}/CaseProgression/Case/__caseId__/Contract/__contractId__/PLRevertToFinalWarningSent`,
      method: apiMethod?.patch,
      methodname: 'PLRevertToFinalWarningSent',
    },
    plGenerateNotice: {
      url: `${apiUrl?.general}/CaseProgression/Case/__caseId__/Contract/__contractId__/PLGenerateNotice`,
      method: apiMethod?.patch,
      methodname: 'PLGenerateNotice',
    },
    privateLandAppealAction: {
      url: `${apiUrl?.general}Appeal/Contract/__contractId__/AppealAction`,
      method: apiMethod?.put,
      methodname: 'privateLandAppealAction',
    },
    acceptRepAtOFR: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/AcceptRepAtOFR`,
      method: apiMethod?.patch,
      methodname: 'AcceptRepAtOFR',
    },
    rejectRepAtOFR: {
      url: `${apiUrl?.general}CaseProgression/Case/__caseId__/Contract/__contractId__/RejectRepAtOFR`,
      method: apiMethod?.patch,
      methodname: 'RejectRepAtOFR',
    },
  },
  Debt: {
    getDebts: {
      url: `${apiUrl?.general}Debt/Contract/__contractId__/GetDebt`,
      method: apiMethod?.post,
      methodname: 'Debts',
    },
    generateNewRequest: {
      url: `${apiUrl?.general}Debt/Contract/__contractId__/GenerateNewRequest`,
      method: apiMethod?.post,
      methodname: 'Debts',
    },
    getDebtCaseSearch: {
      url: `${apiUrl?.general}Debt/Contract/__contractId__/Debt/GetDebtCaseSearch`,
      method: apiMethod?.post,
      methodname: 'Debts',
    },
    getDebtProcessed: {
      url: `${apiUrl?.general}Debt/Contract/__contractId__/Debt`,
      method: apiMethod?.post,
      methodname: 'Debts',
    },
    updateDebtProcess: {
      url: `${apiUrl?.general}Debt/Contract/__contractId__/Debt/UpdateDebtProcess`,
      method: apiMethod?.put,
      methodname: 'Debts',
    },
  },
  Warrant: {
    getWarrants: {
      url: `${apiUrl?.general}Warrant/Contract/__contractId__/GetWarrants`,
      method: apiMethod?.post,
      methodname: 'Warrants',
    },
    getWarrant: {
      url: `${apiUrl?.general}Warrant/__id__/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'Warrants',
    },
    generateNewRequest: {
      url: `${apiUrl?.general}Warrant/Contract/__contractId__/GenerateNewRequest`,
      method: apiMethod?.post,
      methodname: 'Warrant',
    },
    getWarrantCaseSearch: {
      url: `${apiUrl?.general}Warrant/Contract/__contractId__/GetWarrantCaseSearch`,
      method: apiMethod?.post,
      methodname: 'Warrant',
    },
    updateWarrantProcess: {
      url: `${apiUrl?.general}Warrant/Contract/__contractId__/WarrantProcess`,
      method: apiMethod?.put,
      methodname: 'Warrant',
    },
  },
  PrintBatch: {
    PrintBatchList: {
      url: `${apiUrl?.general}PrintBatches/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'Debts',
    },
    PrintBatchDownLoad: {
      url: `${apiUrl?.general}PrintBatch/__printBatchId__/Contract/__contractId__/__contractType__/Download`,
      method: apiMethod?.get,
      methodname: 'PrintBatch',
    },
    getPDFBlobFileLocation: {
      url: `${apiUrl?.general}PrintBatch/__batchId__/LocalPrintLocations`,
      method: apiMethod?.get,
      methodname: 'localPrinting File Location',
    },
    updatePrintBathConfirm: {
      url: `${apiUrl?.general}PrintBatch/Status`,
      method: apiMethod?.put,
      methodname: 'update print batch status',
    },
  },
  foreignDebtRecovery: {
    foreignDebtRecoveryList: {
      url: `${apiUrl?.general}ForeignDebtRecovery/Contract/__contractId__/GetForeignDebts`,
      method: apiMethod?.post,
      methodname: 'foreignDebtRecoveryList',
    },
    foreignDebtRecovery: {
      url: `${apiUrl?.general}ForeignDebtRecovery/Contract/__contractId__/ForeignDebt`,
      method: apiMethod?.post,
      methodname: 'foreignDebtRecovery',
    },
  },
  BailiffBatch: {
    BailiffBatchList: {
      url: `${apiUrl?.general}Bailiff/Contract/__contractId__/Batches`,
      method: apiMethod?.post,
      methodname: 'BailiffBatchList',
    },
    BailiffBatchExportXMLGeneration: {
      url: `${apiUrl?.general}Bailiff/Contract/__contractId__/ExportXMLGeneration`,
      sheriffExportUrl: `${apiUrl?.general}Bailiff/Contract/__contractId__/SheriffOfficerExport`,
      method: apiMethod?.get,
      methodname: 'ExportXMLGeneration',
    },
    BailiffDetails: {
      url: `${apiUrl?.general}Bailiff/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'get Bailiff Details',
    },
  },
  BailiffMessage: {
    BailiffMessageList: {
      url: `${apiUrl?.general}Bailiff/Contract/__contractId__/Messages`,
      method: apiMethod?.post,
      methodname: 'BailiffMessage',
    },
    BailiffMessageAction: {
      url: `${apiUrl?.general}Bailiff/Contract/__contractId__/Batch/__batchId__/MessageAction`,
      method: apiMethod?.get,
      methodname: 'BailiffMessage',
    },
  },
  timezone: {
    url: `${apiUrl?.general}TimeZone/GetTimeZone`,
    method: apiMethod?.post,
    methodname: 'timezone',
  },
  advanceSearch: {
    searchColumnData: {
      url: `${apiUrl?.case}/GetAdvancedSearchColumnData/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'to get the Search field Data',
    },
    searchColumnValueData: {
      url: `${apiUrl?.case}/GetAdvancedSearch/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'To get the column value',
    },
    searchColumnValueDataExport: {
      url: `${apiUrl?.case}/GetAdvancedSearchExport/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'To get the column value',
    },
    storePreference: {
      url: `${apiUrl?.case}/AdvancedSearchColumnPicker`,
      method: apiMethod?.put,
      methodname:
        'To store the column filter preference against the user account',
    },
    getPreference: {
      url: `${apiUrl?.case}/AdvancedSearchColumnPicker`,
      method: apiMethod?.get,
      methodname:
        'To get the stored column filter preference against the user account',
    },
  },
  Location: {
    getLocation: {
      url: `${apiUrl?.general}Locations`,
      method: apiMethod?.post,
      methodname: 'Locations',
    },
    getLocationZone: {
      url: `${apiUrl?.general}Zone/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'Locations',
    },
    deleteLocation: {
      url: `${apiUrl?.general}Location`,
      method: apiMethod?.delete,
      methodname: 'Locations',
    },
    postLocation: {
      url: `${apiUrl?.general}Location`,
      method: apiMethod?.post,
      methodname: 'Location',
    },
    GetDetailLocation: {
      url: `${apiUrl?.general}Location/__locationId__/Contract/__contractId__/GetLocation`,
      method: apiMethod?.get,
      methodname: 'Location',
    },
    upload: {
      url: `${apiUrl?.general}Location/Upload`,
      method: apiMethod?.post,
      methodname: 'PostLocation',
    },
    locationSampleDataDownload: {
      url: `${apiUrl?.general}template/Download`,
      method: apiMethod?.post,
      methodname: 'locationSampleDataDownload',
    },
    getLocationErrorsExport: {
      url: `${apiUrl?.general}Location/GetLocationErrorsExport`,
      method: apiMethod?.post,
      methodname: 'getLocationErrorsExport',
    },
    getLocationErrors: {
      url: `${apiUrl?.general}Location/GetLocationErrors`,
      method: apiMethod?.post,
      methodname: 'getLocationErrors',
    },
    validationStatus: {
      url: `${apiUrl?.general}Location/ValidationStatus`,
      method: apiMethod?.post,
      methodname: 'validationStatus',
    },
    cameraType: {
      url: `${apiUrl?.general}Location/CameraType`,
      method: apiMethod?.get,
      methodname: 'cameraType',
    },
    cameraMode: {
      url: `${apiUrl?.general}Location/CameraMode`,
      method: apiMethod?.get,
      methodname: 'cameraMode',
    },
    getContraventionCodesByLocationGroup: {
      url: `${apiUrl?.general}Contract/__contractId__/ContraventionCodesByLocationGroup`,
      method: apiMethod?.get,
      methodname: 'ContraventionCodesByLocationGroup',
    },
    exportLocation: {
      url: `${apiUrl?.general}Location/Export`,
      method: apiMethod?.get,
      methodname: 'Export Location',
    },
    locationType: {
      url: `${apiUrl?.general}Location/GetLocationTypes`,
      method: apiMethod?.get,
      methodname: 'Location Types',
    },
    warningLetterTemplate: {
      url: `${apiUrl.general}Template/TemplateList`,
      method: apiMethod.post,
      methodname: 'Unique Warning Letter Template',
    },
    getCPZLocationTypes: {
      url: `${apiUrl?.general}Location/GetCPZLocationTypes`,
      method: apiMethod?.get,
      methodname: 'GetCPZLocationTypes',
    },
  },
  GetReportToken: {
    getReportToken: {
      url: `${apiUrl?.general}PowerBI`,
      method: apiMethod?.get,
      methodname: 'PowerBI',
    },
  },
  preDebtList: {
    enquiryBatchList: {
      url: `${apiUrl?.general}PreDebt/Contract/__contractId__/GetPreDebtRequest`,
      method: apiMethod?.post,
      methodname: 'preDebtEnquiryBatchList',
    },
    responseBatchList: {
      url: `${apiUrl?.general}PreDebt/Contract/__contractId__/GetPreDebtResponse`,
      method: apiMethod?.post,
      methodname: 'preDebtResponseBatchList',
    },
    generateNewRequest: {
      url: `${apiUrl?.general}PreDebt/Contract/__contractId__/GenerateNewRequest`,
      method: apiMethod?.post,
      methodname: 'preDebtResponseBatchList',
    },
  },
  Bailiff: {
    getBailiffs: {
      url: `${apiUrl?.general}GetBailiffs`,
      method: apiMethod?.post,
      methodname: 'GetBailiffs',
    },
    postBailiff: {
      url: `${apiUrl?.general}Bailiff`,
      method: apiMethod?.post,
      methodname: 'Bailiff',
    },
    deleteBailiff: {
      url: `${apiUrl?.general}Bailiff/Contract/__contractId__`,
      method: apiMethod?.delete,
      methodname: 'Bailiff',
    },
    GetById: {
      url: `${apiUrl?.general}Bailiff/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'GetBailiff',
    },
  },
  integration: {
    getContracts: {
      url: `${apiUrl?.general}Integrations`,
      method: apiMethod?.post,
      methodname: 'getContracts',
    },
    updateIntegration: {
      url: `${apiUrl?.general}Integration`,
      method: apiMethod?.put,
      methodname: 'updateIntegration',
    },
    updateIntegration: {
      url: `${apiUrl?.general}Integration`,
      method: apiMethod?.put,
      methodname: 'updateIntegration',
    },
  },

  GetLinkedCase: {
    url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/GetLinkedCasesByVRM`,
    method: apiMethod?.post,
    methodname: 'GetLinkedCase',
  },
  Branding: {
    getBranding: {
      url: `${apiUrl?.general}WhiteLabel/Brandingconfigurations`,
      method: apiMethod?.post,
      methodname: 'BrandingList',
    },
    deleteBranding: {
      url: `${apiUrl?.general}WhiteLabel`,
      method: apiMethod?.delete,
      methodname: 'Delete Branding',
    },
    getByIdBranding: {
      url: `${apiUrl?.general}WhiteLabel`,
      method: apiMethod?.get,
      methodname: 'Get By ID Branding',
    },
    getByIdBrandingConfiguration: {
      url: `${apiUrl?.general}WhiteLabel/ConfigurationSetting`,
      method: apiMethod?.post,
      methodname: 'Branding configuration post method',
    },
    getByIdBrandingAttachment: {
      url: `${apiUrl?.general}WhiteLabel/Attachments`,
      method: apiMethod?.post,
      methodname: 'Branding Attachments post method',
    },
    getByIdBrandingHeaderFooter: {
      url: `${apiUrl?.general}WhiteLabel/HeaderFooter`,
      method: apiMethod?.post,
      methodname: 'Branding HeaderFooter post method',
    },
    getByIdBrandingPublish: {
      url: `${apiUrl?.general}WhiteLabel/Publish`,
      method: apiMethod?.post,
      methodname: 'Branding Publish post method',
    },
    getPaymentTypes: {
      url: `${apiUrl?.general}WhiteLabel/PaymentTypes`,
      method: apiMethod?.get,
      methodname: 'Branding Publish post method',
    },
  },
  BulkUploadCase: {
    getBulkUpdateCaseSearch: {
      url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/BulkUpdateCaseSearch`,
      method: apiMethod?.get,
      methodname: 'BulkUpdateCaseSearch',
    },
    caseSampleDataDownload: {
      url: `${apiUrl?.general}template/Download`,
      method: apiMethod?.post,
      methodname: 'caseSampleDataDownload',
    },
    caseCSVFileUpload: {
      url: `${apiUrl?.case}/Contract/__contractId__/Upload`,
      method: apiMethod?.post,
      methodname: 'CSVFileUpload',
    },
    caseCSVFileUploadFileError: {
      url: `${apiUrl?.case}/CaseErrors`,
      method: apiMethod?.post,
      methodname: 'ErrorFileData',
    },
    caseCSVFileUploadSkipErrorFileExport: {
      url: `${apiUrl?.case}/CaseErrorsExport`,
      method: apiMethod?.post,
      methodname: 'skip Error File Data',
    },
    caseCSVFileUploadFinalData: {
      url: `${apiUrl?.case}/ValidationStatus`,
      method: apiMethod?.post,
      methodname: 'File Data upload',
    },
    getStage: {
      url: `${apiUrl?.case}/Contract/__contractId__/CaseStage`,
      method: apiMethod?.get,
      methodname: 'CaseStage',
    },
    getStatus: {
      url: `${apiUrl?.case}/Contract/__contractId__/CaseStatus/Stage/__stageId__`,
      method: apiMethod?.get,
      methodname: 'CaseStatus',
    },
    getCancelReason: {
      url: `${apiUrl?.general}CancelReason/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'getCancelReason',
    },
    BulkBatchCaseValidate: {
      url: `${apiUrl?.case}/Contract/__contractId__/BulkBatchCaseValidate`,
      method: apiMethod?.post,
      methodname: 'BulkBatchCaseValidate',
    },
    BulkBatchCaseUpdate: {
      url: `${apiUrl?.case}/Contract/__contractId__/BulkBatchCaseUpdate`,
      method: apiMethod?.put,
      methodname: 'BulkBatchCaseUpdate',
    },
    bulkCaseNotesAndAttachments: {
      url: `${apiUrl?.case}/Contract/__contractId__/BulkCaseNotesAndAttachments`,
      method: apiMethod?.post,
      methodname: 'BulkCaseNotesAndAttachments',
    },
    cancelBatch: {
      url: `${apiUrl?.case}/Contract/__contractId__/Batch/__batchId__`,
      method: apiMethod?.delete,
      methodname: 'cancelBatch',
    },
    batchCaseNumbers: {
      url: `${apiUrl?.case}/Contract/__contractId__/BatchCaseNumbers/__batchId__`,
      method: apiMethod?.get,
      methodname: 'batchCaseNumbers',
    },
    getCaseReportList: {
      url: `${apiUrl?.general}CaseReport/Contract/__contractId__/batch/__batchId__`,
      method: apiMethod?.post,
      methodname: 'getCaseReportList',
    },
    caseReportCommit: {
      url: `${apiUrl?.general}CaseReport/Contract/__contractId__/batch/__batchId__`,
      method: apiMethod?.put,
      methodname: 'caseReportCommit',
    },
    caseReportDownload: {
      url: `${apiUrl?.general}CaseReport/Contract/__contractId__/batch/__batchId__/Download`,
      method: apiMethod?.post,
      methodname: 'caseReportDownload',
    },
    getCaseSettingData: {
      url: `${apiUrl?.general}CaseReport/Contract/__contractId__/batch/__batchId__/Page`,
      method: apiMethod?.get,
      methodname: 'getCaseSettingData',
    },
    getBatches: {
      url: `${apiUrl?.case}/Contract/__contractId__/Batches`,
      method: apiMethod?.post,
      methodname: 'getBatches',
    },
    listApproval: {
      url: `${apiUrl?.case}/Contract/__contractId__/Batch/__batchId__/BulkApproval`,
      method: apiMethod?.put,
      methodname: 'listApproval',
    },
  },
  Purge: {
    getPurgeList: {
      url: `${apiUrl?.general}Purge/PurgeList`,
      method: apiMethod?.post,
      methodname: 'GetPurgeList',
    },
    postPurge: {
      url: `${apiUrl?.general}Purge`,
      method: apiMethod?.post,
      methodname: 'PostPurge',
    },
    deletePurge: {
      url: `${apiUrl?.general}Purge`,
      method: apiMethod?.delete,
      methodname: 'DeletePurge',
    },
    getPurgeById: {
      url: `${apiUrl?.general}Purge`,
      method: apiMethod?.get,
      methodname: 'GetPurgeById',
    },
    putPurge: {
      url: `${apiUrl?.general}Purge`,
      method: apiMethod?.put,
      methodname: 'PutPurge',
    },
  },
  OCR: {
    postScan: {
      url: `${apiUrl?.general}OCR/Scan`,
      method: apiMethod?.post,
      methodname: 'postScan',
    },
  },

  officerTracking: {
    getCEOLocationNameAPI: {
      url: 'https://atlas.microsoft.com/search/address/reverse/crossstreet/json?&api-version=1.0&subscription-key=__AzureMapSubscriptionKey__&language=en-US&query=__LatandLongCoordinate__',
      method: apiMethod?.get,
      methodname: 'get the GEO location based on coordinate',
    },
    getListOfCeo: {
      url: `${apiUrl?.general}CEO/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'getListOfCeo',
    },
    getLocationHistory: {
      url: `${apiUrl?.general}CEO/location-history?contractId=__contractId__&startDate=__startDate__&endDate=__endDate__&userIds=__userIds__`,
      method: apiMethod?.get,
      methodname: 'getLocationHistory',
    },
    geoFenceLogs: {
      url: `${apiUrl?.general}GeoFenceLogs`,
      method: apiMethod?.post,
      methodname: 'GeoFenceLogs',
    },
  },

  debtReview: {
    getDebtReviewList: {
      url: `${apiUrl?.general}Debt/Contract/__contractId__/GetDebtReview`,
      method: apiMethod?.post,
      methodname: 'getDebtReviewList',
    },
    cancelCases: {
      url: `${apiUrl?.general}Debt/Contract/__contractId__/DebtReviewCasesCancel`,
      method: apiMethod?.put,
      methodname: 'cancelCases',
    },
  },
  pcnOnHoldAndOffHold: {
    pcnremoveOffHold: {
      url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/__contractType__/OffHold`,
      method: apiMethod?.patch,
      methodname: 'remove off hold',
    },
    onHold: {
      url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/OnHold`,
      method: apiMethod?.patch,
      methodname: 'remove off hold',
    },
    onHoldReasons: {
      url: `${apiUrl?.general}HoldReason/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'onHoldReasons',
    },
    swapCaseOnHold: {
      url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/SwapHold`,
      method: apiMethod?.patch,
      methodname: 'swapCaseOnHold',
    },
    pcnActionLookup: {
      url: `${apiUrl?.case}/PCNActionLookup`,
      method: apiMethod?.get,
      methodname: 'pcnActionLookup',
    },
  },
  attachmentReallocation: {
    getAttachmentsList: {
      url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/reallocationAttachments`,
      method: apiMethod?.post,
      methodname: 'get attachments list',
    },
    getCaseData: {
      url: `${apiUrl?.case}/Contract/__contractId__/searchForReallocation`,
      method: apiMethod?.post,
      methodname: 'CaseSearch',
    },
    attachmentReallocation: {
      url: `${apiUrl?.case}/Contract/__contractId__/attachmentReallocate`,
      method: apiMethod?.put,
      methodname: 'attachement reallocation',
    },
  },
  PCNNumberReservation: {
    getCEOIds: {
      url: `${apiUrl?.general}CEO/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'getCEOIds',
    },
    getPCNNumberReservationList: {
      url: `${apiUrl?.general}ManualCase/Contract/__contractId__/GetReservedPCNNumbers`,
      method: apiMethod?.post,
      methodname: 'GetPCNNumberReservationList',
    },
    getCreatePCNReservationValidation: {
      url: `${apiUrl?.general}ManualCase/Contract/__contractId__/CEO/__cEOId__/CreatePCNReservationValidation`,
      method: apiMethod?.get,
      methodname: 'getCreatePCNReservationValidation',
    },
    postPCNReservation: {
      url: `${apiUrl?.general}ManualCase/Contract/__contractId__/CreatePCNReservation`,
      method: apiMethod?.post,
      methodname: 'postPCNReservation',
    },
    getDownloadPCNsReservation: {
      url: `${apiUrl?.general}ManualCase/Contract/__contractId__/PCN/__pcnId__/DownloadPCNsReservation`,
      method: apiMethod?.get,
      methodname: 'getDownloadPCNsReservation',
    },
    postSendMailPCNsReservation: {
      url: `${apiUrl?.general}ManualCase/Contract/__contractId__/PCN/__pcnId__/SendMailPCNsReservation`,
      method: apiMethod?.post,
      methodname: 'postSendMailPCNsReservation',
    },
  },
  manualCase: {
    vehicleMake: {
      url: `${apiUrl?.general}Vehicle/Make`,
      method: apiMethod?.get,
      methodname: 'vehicleMake',
    },
    vehicleColor: {
      url: `${apiUrl?.general}Vehicle/Color`,
      method: apiMethod?.get,
      methodname: 'vehicleColor',
    },
    getReason: {
      url: `${apiUrl?.general}ManualCase/Reason`,
      method: apiMethod?.get,
      methodname: 'caseReason',
    },
    getCeoId: {
      url: `${apiUrl?.general}CEO/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'ceoID',
    },
    caseNumber: {
      url: `${apiUrl?.general}Case/ReservedCaseNumbers/Contract/__contractId__/User/__userId__`,
      method: apiMethod?.get,
      methodname: 'caseNumber',
    },
    validateSession: {
      url: `${apiUrl?.general}DVLA/ParkingSession`,
      method: apiMethod?.post,
      methodname: 'validateSession',
    },
    contravention: {
      url: `${apiUrl?.general}ContraventionCode/Contract/__contractId__/Location/__locationId__`,
      method: apiMethod?.get,
      methodname: 'contravention',
    },
    wheelPosition: {
      url: `${apiUrl?.general}WheelPosition`,
      method: apiMethod?.get,
      methodname: 'wheelPosition',
    },
    serviceMethod: {
      url: `${apiUrl?.general}ServiceMethod/Contract/__contractType__`,
      method: apiMethod?.get,
      methodname: 'serviceMethod',
    },
    createPcn: {
      url: `${apiUrl?.general}ManualCase/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'createPcn',
    },
    reportFault: {
      url: `${apiUrl?.general}ManualReportFault/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'reportFault',
    },
    faultType: {
      url: `${apiUrl?.general}FaultType/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'faultType',
    },
    vehicleType: {
      url: `${apiUrl?.general}Vehicle/Type/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'vehicleType',
    },
  },
  contractConfigData: {
    // Note: API response includes WorkflowOpenTaskCount parameter for displaying open task count
    getContractConfigData: {
      url: `${apiUrl?.general}Contract/__contractId__/Settings`,
      method: apiMethod?.get,
      methodname: 'getContractData',
    },
    getContractAutomateConfigData: {
      url: `${apiUrl?.general}Contract/__contractId__/AutomateSettings`,
      method: apiMethod?.get,
      methodname: 'getContractData',
    },
  },
  haloIntegration: {
    getAuthToken: {
      url: `/auth/token`,
      method: apiMethod?.post,
      methodname: 'getAuthToken from HALO server',
    },
    getCaseCategory: {
      url: `${apiUrl?.general}Halo/TicketTypes`,
      method: apiMethod?.get,
      methodname: 'get Ticket category from HALO server',
    },
    ticketCreate: {
      url: `${apiUrl?.general}Halo/Ticket`,
      method: apiMethod?.post,
      methodname: 'Create ticket in HALO app',
    },
    addAttachmentForTicket: {
      url: `${apiUrl?.general}attachment`,
      method: apiMethod?.post,
      methodname: 'Add Attachment for the Ticket',
    },
    eventLogged: {
      url: `${apiUrl?.general}halo/event`,
      method: apiMethod?.post,
      methodname: 'Add the usd event in HALO app',
    },
    validateUserDetails: {
      url: `${apiUrl?.general}/Halo/ValidateUser/__search__`,
      method: apiMethod?.get,
      methodname: 'Validate the user exist or not',
    },
    addUserDetail: {
      url: `${apiUrl?.general}Halo/User`,
      method: apiMethod?.post,
      methodname: 'Create new user in to HALO service',
    },
  },
  tasks: {
    getTaskList: {
      url: `${apiUrl?.general}Task/CEOTasks/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'getTaskList',
    },
    postTask: {
      url: `${apiUrl?.general}Task/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'postTask',
    },
    getTaskStatus: {
      url: `${apiUrl?.general}Task/TaskStatus/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'getTaskStatus',
    },
    getCategory: {
      url: `${apiUrl?.general}Task/Category/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'getCategory',
    },
    getCEOs: {
      url: `${apiUrl?.general}CEO/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'getCEOs',
    },
    reAssign: {
      url: `${apiUrl?.general}Task/ReAssign/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'reAssign',
    },
    cancelTask: {
      url: `${apiUrl?.general}Task/CancelTask/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'cancelTask',
    },
    getTask: {
      url: `${apiUrl?.general}Task/Contract/__contractId__/CEOTask/__taskId__`,
      method: apiMethod?.get,
      methodname: 'getTask',
    },
    deleteTask: {
      url: `${apiUrl?.general}Task/__taskId__`,
      method: apiMethod?.delete,
      methodname: 'deleteTask',
    },
    closeTasks: {
      url: `${apiUrl?.general}Task/Contract/__contractId__/CloseTasks`,
      method: apiMethod?.post,
      methodname: 'closeTasks',
    },
    createWorkflowTask: {
      url: `${apiUrl?.general}Workflow/Case/__caseId__/Contract/__contractId__/ManualWorkflowTask`,
      method: apiMethod?.post,
      methodname: 'createWorkflowTask',
    },
    postNotesAndAttachments: {
      url: `${apiUrl?.general}Task/NotesAndAttachments/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'postNotesAndAttachments',
    },
    getHistory: {
      url: `${apiUrl?.general}Task/Contract/__contractId__/TaskHistory/__taskId__`,
      method: apiMethod?.get,
      methodname: 'getHistory',
    },
    downloadCEOTaskReport: {
      url: `${apiUrl?.general}Task/__taskId__/Contract/__contractId__/DownloadCEOTaskReport`,
      method: apiMethod?.get,
      methodname: 'downloadCEOTaskReport',
    },
  },
  sourceType: {
    getSourceType: {
      url: `${apiUrl?.case}/SourceType`,
      method: apiMethod?.get,
      methodname: 'sourceType',
    },
  },
  ceoOfficerTrack: {
    getActiveCEOOfficer: {
      url: `${apiUrl?.general}CEOOfficerTrack/ActiveOfficers/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'getActiveCEOOfficer',
    },
  },
  groundReason: {
    getGroundReasons: {
      url: `${apiUrl?.general}GroundReasons`,
      method: apiMethod?.post,
      methodname: 'getGroundReasons',
    },
    postGroundReason: {
      url: `${apiUrl?.general}GroundReason`,
      method: apiMethod?.post,
      methodname: 'postGroundReason',
    },
    deleteGroundReason: {
      url: `${apiUrl?.general}GroundReason`,
      method: apiMethod?.delete,
      methodname: 'deleteGroundReason',
    },
    getNoticeType: {
      url: `${apiUrl?.general}ContraventionCode/NoticeType`,
      method: apiMethod?.get,
      methodname: 'getNoticeType',
    },
  },
  cAndRConfiguration: {
    cancellationList: {
      url: `${apiUrl?.general}ClampAndRemoval/CancelReason/Pagination`,
      method: apiMethod?.post,
      methodname: 'cancellationReasonList',
    },
    csvExport: {
      url: `${apiUrl?.general}ClampAndRemoval/CancelReason/Export`,
      method: apiMethod?.get,
      methodname: 'cancellationReasonCSVExport',
    },
    postCRCancellationReason: {
      url: `${apiUrl?.general}ClampAndRemoval/cancelReason`,
      method: apiMethod?.post,
      methodname: 'postCRCancellationReason',
    },
    cancellationReasonDelete: {
      url: `${apiUrl?.general}ClampAndRemoval/cancelReason/__caseId__`,
      method: apiMethod?.delete,
      methodname: 'postCRCancellationDelete',
    },
    cancellationReasonEditGet: {
      url: `${apiUrl?.general}ClampAndRemoval/cancelReason/__caseId__`,
      method: apiMethod?.get,
      methodname: 'postCRCancellationGet',
    },
    cancellationReasonEdit: {
      url: `${apiUrl?.general}ClampAndRemoval/cancelReason/`,
      method: apiMethod?.put,
      methodname: 'postCRCancellationEdit',
    },
    cancellationReasonSampleDownload: {
      url: `${apiUrl?.general}ClampAndRemoval/CancelReason/Download`,
      method: apiMethod?.post,
      methodname: 'cancellationReasonSampleDownload',
    },
    cancellationReasonUpload: {
      url: `${apiUrl?.general}ClampAndRemoval/CancelReason/Upload`,
      method: apiMethod?.post,
      methodname: 'cancellationReasonSampleDownload',
    },
    getCancellationReasonErrors: {
      url: `${apiUrl?.general}ClampAndRemoval/CancelReason/GetCancelReasonErrors`,
      method: apiMethod?.post,
      methodname: 'getCancellationReasonErrors',
    },
    cancellationReasonValidationStatus: {
      url: `${apiUrl?.general}ClampAndRemoval/CancelReason/ValidationStatus`,
      method: apiMethod?.post,
      methodname: 'cancellationReasonValidationStatus',
    },
    cancellationReasonErrorExport: {
      url: `${apiUrl?.general}ClampAndRemoval/CancelReason/GetCancelReasonErrorsExport`,
      method: apiMethod?.post,
      methodname: 'cancellationReasonErrorExport',
    },
  },

  geoFenceSetUp: {
    getGeoFenceSetUpList: {
      url: `${apiUrl?.general}GeoFences`,
      method: apiMethod?.get,
      methodname: 'getGeoFenceSetUpList',
    },
    saveGeoFence: {
      url: `${apiUrl?.general}/GeoFence`,
      method: apiMethod?.post,
      methodname: 'saveGeoFence',
    },
    updateGeoFence: {
      url: `${apiUrl?.general}/GeoFence`,
      method: apiMethod?.patch,
      methodname: 'updateGeoFence',
    },
    deleteGeoFence: {
      url: `${apiUrl?.general}/GeoFence`,
      method: apiMethod?.delete,
      methodname: 'deleteGeoFence',
    },
    getGeoFenceSetUp: {
      url: `${apiUrl?.general}GeoFence`,
      method: apiMethod?.get,
      methodname: 'getGeoFenceSetUp',
    },
  },

  poundLocation: {
    postCRpoundLocation: {
      url: `${apiUrl?.general}poundLocation`,
      method: apiMethod?.post,
      methodname: 'postCRpoundLocation',
    },
    poundLocationList: {
      url: `${apiUrl?.general}PoundLocation/Pagination`,
      method: apiMethod?.post,
      methodname: 'poundLocationList',
    },
    poundLocationDelete: {
      url: `${apiUrl?.general}PoundLocation/__poundLocationID__`,
      method: apiMethod?.delete,
      methodname: 'postCRCancellationDelete',
    },
    poundLocationEditGet: {
      url: `${apiUrl?.general}PoundLocation/__poundLocationID__`,
      method: apiMethod?.get,
      methodname: 'postCRCancellationGet',
    },
  },
  prioritySettings: {
    prioritySettingsList: {
      url: `${apiUrl?.general}ClampAndRemoval/PrioritySetting/Rules`,
      method: apiMethod?.post,
      methodname: 'postCRCancellationGet',
    },
  },
  prioritySettingData: {
    editOrganisationData: {
      url: `${apiUrl?.general}organisation`,
      method: apiMethod?.get,
      methodname: 'get Organisation by ID',
    },
    contractsByOrganisation: {
      url: `${apiUrl?.general}BackOffice/ContractsByOrganisation/__OrganisationId__`,
      method: apiMethod?.get,
      methodname: 'Get Contracts By Organisation',
    },
    getContraventionCodes: {
      url: `${apiUrl?.general}BackOffice/Contract/__ContractId__/ContraventionCodes`,
      method: apiMethod?.get,
      methodname: 'Get Contravention Codes by Contracts',
    },
    getContraventionLocation: {
      url: `${apiUrl?.general}BackOffice/Contract/__ContractId__/Locations`,
      method: apiMethod?.get,
      methodname: 'Get Contravention Location by Contracts',
    },
    addPrioritySettingRule: {
      url: `${apiUrl?.general}ClampAndRemoval/PrioritySetting/Contract/__ContractId__/Rule`,
      method: apiMethod?.post,
      methodname: 'Add Priority Setting rules',
    },
    deletePriorityRule: {
      url: `${apiUrl?.general}ClampAndRemoval/PrioritySetting/__PriorityRuleId__`,
      method: apiMethod?.delete,
      methodname: 'Delete Priority Setting rules',
    },
    getPriorityRuleDetails: {
      url: `${apiUrl?.general}ClampAndRemoval/PrioritySetting/Contract/__ContractId__/Rule`,
      method: apiMethod?.get,
      methodname: 'Get Priority Setting rules',
    },
    editPriorityRuleDetails: {
      url: `${apiUrl?.general}ClampAndRemoval/PrioritySetting/Contract/__ContractId__/Rule`,
      method: apiMethod?.put,
      methodname: 'Put Priority Setting rules',
    },
    getPriorityRules: {
      url: `${apiUrl?.general}ClampAndRemoval/PrioritySetting/RulePriorities`,
      method: apiMethod?.get,
      methodname: 'Get Priority Setting rules',
    },
  },
  truck: {
    truckList: {
      url: `${apiUrl?.general}ClampAndRemoval/Truck/Trucks`,
      method: apiMethod?.post,
      methodname: 'Getting list of trucks available',
    },
    truckDelete: {
      url: `${apiUrl?.general}ClampAndRemoval/Truck/__TruckId__`,
      method: apiMethod?.delete,
      methodname: 'Deleting a list with id',
    },
    truckTypes: {
      url: `${apiUrl?.general}ClampAndRemoval/Truck/TruckTypes`,
      method: apiMethod?.get,
      methodname: 'Getting list of Truck Types available',
    },
    getTruckDetails: {
      url: `${apiUrl?.general}ClampAndRemoval/Truck/__TruckId__`,
      method: apiMethod?.get,
      methodname: 'Getting The details of a truck',
    },
    truckEdit: {
      url: `${apiUrl?.general}ClampAndRemoval/Truck`,
      method: apiMethod?.put,
      methodname: 'Editing a Truck entry',
    },
    addTruckField: {
      url: `${apiUrl?.general}ClampAndRemoval/Truck/Add`,
      method: apiMethod?.post,
      methodname: 'Adding a new Truck entry',
    },
  },
  vehicleType: {
    getListOfVehicleType: {
      url: `${apiUrl?.general}VehicleTypes`,
      method: apiMethod?.post,
      methodname: 'get list of vehicle type data',
    },
    insertVehicleType: {
      url: `${apiUrl?.general}VehicleType`,
      method: apiMethod?.post,
      methodname: 'insert vehicle type data',
    },
    updateVehicleType: {
      url: `${apiUrl?.general}VehicleType/__vehicleTypeId__`,
      method: apiMethod?.put,
      methodname: 'update vehicle type data',
    },
    deleteVehicleType: {
      url: `${apiUrl?.general}VehicleType/__vehicleTypeId__`,
      method: apiMethod?.delete,
      methodname: 'delete vehicle type data',
    },
    getByIdVehicleType: {
      url: `${apiUrl?.general}VehicleType/__vehicleTypeId__`,
      method: apiMethod?.get,
      methodname: 'get vehicle type data by id',
    },
  },
  jobState: {
    stateTypes: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/JobStates/Contract/__ContractId__`,
      method: apiMethod?.get,
      methodname: 'Getting list of State Types available',
    },
    enforcementType: {
      url: `${apiUrl?.general}ClampAndRemoval/EnforcementType`,
      method: apiMethod?.get,
      methodname: 'Getting list of Enforcement Types available',
    },
    jobList: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/Contract/__ContractId__`,
      method: apiMethod?.post,
      methodname: 'Getting list of Jobs  available created via HHD',
    },
    notesList: {
      url: `${apiUrl?.general}ClampAndRemoval/Contract/__contractId__/Job/__JobId__/Notes`,
      method: apiMethod?.post,
      methodname: 'notesList',
    },
    saveNote: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/Note`,
      method: apiMethod?.post,
      methodname: 'saveNote',
    },
    enforcementTypeUpdate: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/__JobId__/EnforcementType/__EnforcementTypeId__`,
      method: apiMethod?.put,
      methodname: 'Updating the Enforcement Id',
    },
    priorityIdUpdate: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/__JobId__/Priority/__PriorityId__`,
      method: apiMethod?.put,
      methodname: 'Updating the Priority Id',
    },
    getJobDetails: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/__JobId__/Contract/__ContractId__/Truck`,
      method: apiMethod?.get,
      methodname: 'Getting job Details',
    },
    eventsList: {
      url: `${apiUrl?.general}ClampAndRemoval/Contract/__contractId__/Job/__JobId__/Events`,
      method: apiMethod?.post,
      methodname: 'eventsList',
    },
    crContactAddressList: {
      url: `${apiUrl?.general}ContactAddresses/Contract/__contractId__/Job/__jobId__/Case/__caseId__`,
      method: apiMethod?.post,
      methodname: 'crContactAddressList',
    },
    deleteCrContactAddress: {
      url: `${apiUrl?.general}ContactAddress/__addressId__/Contract/__contractId__`,
      method: apiMethod?.delete,
      methodname: 'deleteCrContactAddress',
    },
    getCrContactAddress: {
      url: `${apiUrl?.general}ContactAddress/__addressId__/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'getCrContactAddress',
    },
    postCrContactAddress: {
      url: `${apiUrl?.general}ContactAddress/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'postCrContactAddress',
    },
    updateCrContactAddress: {
      url: `${apiUrl?.general}ContactAddress/__addressId__/Contract/__contractId__`,
      method: apiMethod?.put,
      methodname: 'updateCrContactAddress',
    },
    cancelJob: {
      url: `${apiUrl?.general}Job/Job/__JobId__/Contract/__ContractId__/CancelReason/__CancelReasonId__/Cancel`,
      method: apiMethod?.put,
      methodname: 'Cancelling a job',
    },
    getCancelReason: {
      url: `${apiUrl?.general}CancellationReason/Contract/__ContractId__`,
      method: apiMethod?.get,
      methodname: 'getting cancelReason',
    },
    getUnableToLiftReason: {
      url: `${apiUrl?.general}ClampAndRemoval/UnableToLiftReasons`,
      method: apiMethod?.get,
      methodname: 'getting unableToLiftReasons',
    },
    JobUpdate: {
      url: `${apiUrl?.general}ClampAndRemoval/Contract/__ContractId__/UpdateJobStateWithUnableToLiftReason`,
      method: apiMethod?.put,
      methodname: 'Updating a Job',
    },
    jobProcessFlow: {
      url: `${apiUrl?.general}Job/ProcessFlow/EnforcementType/__EnforcementTypeId__`,
      method: apiMethod?.get,
      methodname: 'Getting job processing states list',
    },
  },
  CRAttachments: {
    getAllAttachment: {
      url: `${apiUrl?.general}ClampAndRemoval/Contract/__ContractId__/Job/__jobId__/Attachments`,
      method: apiMethod?.post,
      methodname: 'Get list of CR Attachment',
    },
    addAttachment: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/Attachment`,
      method: apiMethod?.post,
      methodname: 'post attachment against CR',
    },
  },
  CRAssociatedPCN: {
    getAssociatedPcn: {
      url: `${apiUrl?.general}BackOffice/Contract/__contractId__/VRMLinkedCases`,
      method: apiMethod?.post,
      methodname: 'get list of associated pcn',
    },
    getPcnDetails: {
      url: `${apiUrl?.general}BackOffice/Contract/__contractId__/Case/__caseId__/CaseDetail`,
      method: apiMethod?.get,
      methodname: 'get details of associated pcn',
    },
    downloadAssociatedPcn: {
      url: `${apiUrl?.general}/BackOffice/Contract/__contractId__/VRMLinkedCasesDownload`,
      method: apiMethod?.post,
      methodname: 'get list of VRM linked pcn to be downloaded',
    },
  },
  truckMapping: {
    truckMappingList: {
      url: `${apiUrl?.general}ClampAndRemoval/TruckMapping/Contract/__ContractId__`,
      method: apiMethod?.post,
      methodname: 'Getting the list of available truck mapped',
    },
    unassignedTrucks: {
      url: `${apiUrl?.general}ClampAndRemoval/TruckMapping/Contract/__ContractId__/PoundLocation/__poundLocationId__/UnassignedTrucks`,
      method: apiMethod?.get,
      methodname: 'Getting the list of available un assigned truck',
    },
    unassignedObceo: {
      url: `${apiUrl?.general}ClampAndRemoval/TruckMapping/Contract/__ContractId__/PoundLocation/__poundLocationId__/Role/__RoleId__/UnassignedOBCEOs`,
      method: apiMethod?.get,
      methodname: 'Getting the list of available un assigned OBCEO',
    },
    addTruckMapping: {
      url: `${apiUrl?.general}ClampAndRemoval/TruckMapping`,
      method: apiMethod?.post,
      methodname: 'Assigning Truck mapping',
    },
    updateTruckMapping: {
      url: `${apiUrl?.general}ClampAndRemoval/TruckMapping`,
      method: apiMethod?.put,
      methodname: 'Updating Truck mapping',
    },
    deleteTruckMapping: {
      url: `${apiUrl?.general}ClampAndRemoval/TruckMapping/__DeleteId__/Truck/__TruckMappingId__`,
      method: apiMethod?.delete,
      methodname: 'Deleting Truck mapping',
    },
  },
  manualAssignTruck: {
    truckAssign: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/Note`,
      method: apiMethod?.put,
      methodname: 'Truck Assigning',
    },
    availableOBCEOUsers: {
      url: `${apiUrl?.general}ClampAndRemoval/Contract/__ContractId__/Case/__CaseId__/AvailableOBCEOUsers`,
      method: apiMethod?.get,
      methodname: 'Getting Available OBCEO Users',
    },
    availableMCEOUsers: {
      url: `${apiUrl?.general}ClampAndRemoval/Contract/__ContractId__/Case/__CaseId__/AvailableMCEOUsers`,
      method: apiMethod?.get,
      methodname: 'Getting Available MCEO Users',
    },
  },
  poundAllocation: {
    getAvailableBay: {
      url: `${apiUrl?.general}Pound/Location/__locationId__/AvailableBays`,
      method: apiMethod?.get,
      methodname: 'get list of available bays',
    },
    allocateBay: {
      url: `${apiUrl?.general}Pound/Job/__jobId__/Bay/__bookingBayNumber__/BookBay`,
      method: apiMethod?.put,
      methodname: 'allocate bay',
    },
  },
  //will replace once get api team below
  poundAttachments: {
    getAllAttachment: {
      url: `${apiUrl?.general}ClampAndRemoval/Contract/__ContractId__/Job/__jobId__/Attachments`,
      method: apiMethod?.post,
      methodname: 'Get list of pound Attachment',
    },
    addAttachment: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/Attachment`,
      method: apiMethod?.post,
      methodname: 'post attachment against pound',
    },
  },
  poundEventsList: {
    url: `${apiUrl?.general}ClampAndRemoval/Contract/__contractId__/Job/__JobId__/Events`,
    method: apiMethod?.post,
    methodname: 'eventsList',
  },
  poundContactTab: {
    poundContactAddressList: {
      url: `${apiUrl?.general}ContactAddresses/Contract/__contractId__/Job/__jobId__/Case/__caseId__`,
      method: apiMethod?.post,
      methodname: 'crContactAddressList',
    },
    deletePoundContactAddress: {
      url: `${apiUrl?.general}ContactAddress/__addressId__/Contract/__contractId__`,
      method: apiMethod?.delete,
      methodname: 'deleteCrContactAddress',
    },
    getPoundContactAddress: {
      url: `${apiUrl?.general}ContactAddress/__addressId__/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'getCrContactAddress',
    },
    postPoundContactAddress: {
      url: `${apiUrl?.general}ContactAddress/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'postCrContactAddress',
    },
    updatePoundContactAddress: {
      url: `${apiUrl?.general}ContactAddress/__addressId__/Contract/__contractId__`,
      method: apiMethod?.put,
      methodname: 'updateCrContactAddress',
    },
  },
  poundNotesTab: {
    notesList: {
      url: `${apiUrl?.general}ClampAndRemoval/Contract/__contractId__/Job/__JobId__/Notes`,
      method: apiMethod?.post,
      methodname: 'notesList',
    },
    saveNote: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/Note`,
      method: apiMethod?.post,
      methodname: 'saveNote',
    },
  },
  poundList: {
    url: `${apiUrl?.general}Pound/Contract/__contractId__/Vehicles`,
    method: apiMethod?.post,
    methodname: 'poundList',
  },
  getPoundDetails: {
    url: `${apiUrl?.general}ClampAndRemoval/Job/__JobId__/Contract/__ContractId__/Truck`,
    method: apiMethod?.get,
    methodname: 'Getting job Details',
  },
  PoundAssociatedPCN: {
    getAssociatedPcn: {
      url: `${apiUrl?.general}BackOffice/Contract/__contractId__/VRMLinkedCases`,
      method: apiMethod?.post,
      methodname: 'get list of associated pcn',
    },
    getPcnDetails: {
      url: `${apiUrl?.general}BackOffice/Contract/__contractId__/Case/__caseId__/CaseDetail`,
      method: apiMethod?.get,
      methodname: 'get details of associated pcn',
    },
    downloadAssociatedPcn: {
      url: `${apiUrl?.general}/BackOffice/Contract/__contractId__/VRMLinkedCasesDownload`,
      method: apiMethod?.post,
      methodname: 'get list of VRM linked pcn to be downloaded',
    },
  },
  getPoundTruckDetails: {
    url: `${apiUrl?.general}ClampAndRemoval/Job/__JobId__/Contract/__ContractId__/Truck`,
    method: apiMethod?.get,
    methodname: 'Getting Truck Details',
  },
  chargeConfiguration: {
    getListOfChargeConfiguration: {
      url: `${apiUrl?.general}ChargeConfiguration/ChargeConfigurations`,
      method: apiMethod?.post,
      methodname: 'getting the list of all available charge configuration ',
    },
    addChargeData: {
      url: `${apiUrl?.general}ChargeConfiguration`,
      method: apiMethod?.post,
      methodname: 'adding charge',
    },
    updateChargeData: {
      url: `${apiUrl?.general}ChargeConfiguration`,
      method: apiMethod?.put,
      methodname: 'updating charge',
    },
    deleteChargeData: {
      url: `${apiUrl?.general}ChargeConfiguration/__DeleteId__`,
      method: apiMethod?.delete,
      methodname: 'deleting charge data',
    },
    getChargeData: {
      url: `${apiUrl?.general}ChargeConfiguration/__ChargeId__`,
      method: apiMethod?.get,
      methodname: 'getting charge data',
    },
    getChargeConfiguredFilteredContract: {
      url: `${apiUrl?.general}ChargeConfiguration/Contracts`,
      method: apiMethod?.get,
      methodname: 'getting Charge Configuration contract data',
    },
  },
  poundRecordReleasePayment: {
    getListOfCharges: {
      url: `Case/__caseId__/Job/__jobId__/Contract/__contractId__/RecordReleasePayment`,
      method: apiMethod?.get,
      methodname: 'get list of fees and charge details',
    },
    getTotalCharge: {
      url: `${apiUrl?.general}Job/Case/__caseId__/Contract/__contractId__/CurrentCharge`,
      method: apiMethod?.get,
      methodname: 'get list of fees and charge details',
    },
    saveRecordPayRelease: {
      url: `${apiUrl?.general}PoundLocation/RecordPayReleaseStepper`,
      method: apiMethod?.post,
      methodname: 'saveRecordPayRelease',
    },
  },
  crPaymentTab: {
    getPaymentData: {
      url: `${apiUrl?.general}Job/__JobId__/Contract/__ContractId__/Case/__CaseId__`,
      method: apiMethod?.get,
      methodname: 'get list of fees and charge details',
    },
    removeCharge: {
      url: `${apiUrl?.general}Job/Charge/__ChargeId__`,
      method: apiMethod?.delete,
      methodname: 'Removing a charge item',
    },
    paymentHistory: {
      url: `${apiUrl?.general}Payment/Job/__jobId__/History`,
      method: apiMethod?.post,
      methodname: 'paymentHistory',
    },
    undoPaymentJob: {
      url: `${apiUrl?.general}Job/Charge/__ChargeId__/Revert`,
      method: apiMethod?.put,
      methodname: 'undoPaymentJob',
    },
  },
  poundRecordReleaseNotesAttachment: {
    getAttachments: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/__jobId__/Contract/__contractId__/Attachments`,
      method: apiMethod?.get,
      methodname: 'get attachments',
    },
    getNotes: {
      url: `${apiUrl?.general}ClampAndRemoval/Job/__jobId__/Notes`,
      method: apiMethod?.get,
      methodname: 'get notes',
    },
  },
  poundReleaseReason: {
    url: `${apiUrl?.general}PoundLocation/Contract/__ContractId__/PoundReleaseReason`,
    method: apiMethod?.get,
    methodname: 'pound Release Reason',
  },
  poundJobStateAction: {
    url: `${apiUrl?.general}PoundLocation/Job/__jobId__/Contract/__contractId__/JobStateAction`,
    method: apiMethod?.put,
    methodname: 'PoundJobStateAction',
  },
  getDisposeTypes: {
    url: `${apiUrl?.general}PoundLocation/DisposeTypes`,
    method: apiMethod?.get,
    methodname: 'getDisposeTypes',
  },
  trackingList: {
    url: `${apiUrl?.general}Pound/Contract/__contractId__/TruckTracking`,
    method: apiMethod?.post,
    methodname: 'trackingList',
  },
  vehicleTypeLookUpData: {
    url: `${apiUrl?.general}VehicleType/LookupData`,
    method: apiMethod?.get,
    methodname: 'vehileTypeLookUpData',
  },
  sendBriefing: {
    createBriefing: {
      url: `${apiUrl?.general}Briefing/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'createBriefing',
    },
  },
  getBriefingList: {
    url: `${apiUrl?.general}Briefings/Contract/__contractId__`,
    method: apiMethod?.post,
    methodname: 'getBriefingList',
  },
  poundPayment: {
    refundReason: {
      url: `${apiUrl?.general}Payment/RefundReason`,
      method: apiMethod?.get,
      methodname: 'refundReason',
    },
    saveRefund: {
      url: `${apiUrl?.general}Payment/Job/__jobId__/Refund`,
      method: apiMethod?.post,
      methodname: 'saveRefund',
    },
    saveChargeBack: {
      url: `${apiUrl?.general}Payment/Job/__jobId__/ChargeBack`,
      method: apiMethod?.post,
      methodname: 'saveChargeBack',
    },
  },
  deleteBriefingList: {
    url: `${apiUrl?.general}Briefing/__id__/Contract/__contractId__`,
    method: apiMethod?.delete,
    methodname: 'deleteBriefingList',
  },
  releaseReason: {
    releaseReasonList: {
      url: `${apiUrl?.general}PoundReleaseReason/ReleaseReasons`,
      method: apiMethod?.post,
      methodname: 'release reason list API',
    },
    releaseReasonExport: {
      url: `${apiUrl?.general}PoundReleaseReason/Export`,
      method: apiMethod?.get,
      methodname: 'Exporting release reason details',
    },
    addReleaseReason: {
      url: `${apiUrl?.general}PoundReleaseReason`,
      method: apiMethod?.post,
      methodname: 'Adding release reasons',
    },
    crudReleaseReason: {
      url: `${apiUrl?.general}PoundReleaseReason`,
      method: apiMethod?.post,
      methodname: 'Adding and Updating release reasons',
    },
    deletingReleaseReason: {
      url: `${apiUrl?.general}PoundReleaseReason/__DeleteId__`,
      method: apiMethod?.delete,
      methodname: 'Deleting release reason',
    },
    sampleCSVExport: {
      url: `${apiUrl?.general}PoundReleaseReason/SampleCsvDownload`,
      method: apiMethod?.get,
      methodname: 'Exporting sample CSV ',
    },
    csvUpload: {
      url: `${apiUrl?.general}PoundReleaseReason/Upload`,
      method: apiMethod?.post,
      methodname: 'Uploading CSV ',
    },
    getReleaseReasonErrors: {
      url: `${apiUrl?.general}PoundReleaseReason/ReleaseReasonErrors`,
      method: apiMethod?.post,
      methodname: 'getReleaseReasonErrors',
    },
    releaseReasonValidationStatus: {
      url: `${apiUrl?.general}PoundReleaseReason/ValidationStatus`,
      method: apiMethod?.post,
      methodname: 'releaseReasonValidationStatus',
    },
    releaseReasonErrorExport: {
      url: `${apiUrl?.general}PoundReleaseReason/ReleaseReasonErrorsExport`,
      method: apiMethod?.post,
      methodname: 'releaseReasonErrorExport',
    },
  },
  briefingHistory: {
    url: `${apiUrl?.general}Briefing/__briefingId__/BriefingHistory`,
    method: apiMethod?.post,
    methodname: 'briefingHistory',
  },
  briefingPreviewMessage: {
    url: `${apiUrl?.general}Briefing/__briefingId__`,
    method: apiMethod?.get,
    methodname: 'briefingPreviewMessage',
  },
  briefingPreviewMessageExport: {
    url: `${apiUrl?.general}Briefing/Contract/__contractId__/Export`,
    method: apiMethod?.post,
    methodname: 'briefingPreviewMessageExport',
  },
  briefingPreviewReadHistoryExport: {
    url: `${apiUrl?.general}Briefing/__briefingId__/ReadHistoryExport`,
    method: apiMethod?.post,
    methodname: 'briefingPreviewReadHistoryExport',
  },
  validateBriefingEffectiveDate: {
    url: `${apiUrl?.general}Briefing/Contract/__contractId__/ValidateEffectiveDate`,
    method: apiMethod?.post,
    methodname: 'validateBriefingEffectiveDate',
  },
  validateInspectorId: {
    url: `${apiUrl?.general}BackOffice/User/__inspectorId__/IsExist`,
    method: apiMethod?.get,
    methodname: 'validateInspectorId',
  },
  savePoundVehicleGridColumnFilter: {
    url: `${apiUrl?.general}GridSetting/ColumnSetting`,
    method: apiMethod?.post,
    methodname: 'savePoundVehicleGridColumnFilter',
  },
  getPoundVehicleGridColumnFilter: {
    url: `${apiUrl?.general}GridSetting/__gridName__/Contract/__contractId__/Column`,
    method: apiMethod?.get,
    methodname: 'getPoundVehicleGridColumnFilter',
  },
  autoAssignConfiguration: {
    updateAutoAssignConfiguration: {
      url: `${apiUrl?.general}/Workflow/UpdateWorkflowAutoAssign`,
      method: apiMethod?.put,
      methodname: 'updateAutoAssignConfiguration',
    },
    getListOfUsers: {
      url: `${apiUrl?.general}Workflow/Contract/__contractId__/__contractType__/GetAllUsersForWorkflowTask`,
      method: apiMethod?.post,
      methodname: 'getListOfUsers',
    },
    updateAutoAssignStages: {
      url: `${apiUrl?.general}Workflow/Contract/__contractId__/WorkflowConfig/__workflowConfigId__/Stage`,
      method: apiMethod?.post,
      methodname: 'updateAutoAssignStages',
    },
    getListOfStages: {
      url: `${apiUrl?.general}Stage/Contract/__contractType__`,
      method: apiMethod?.get,
      methodname: 'getListOfStages',
    },
  },
  getTaskStatusCount: {
    url: `${apiUrl?.general}Workflow/Contract/__contractId__/Stage/__stageId__/TaskStatus`,
    method: apiMethod?.get,
    methodname: 'getTaskStatusCount',
  },
  getTaskStatusStage: {
    url: `${apiUrl?.general}Workflow/Contract/__contractId__/WorkflowStage`,
    method: apiMethod?.get,
    methodname: 'getTaskStatusStage',
  },
  boUserTaskAutoAssigned: {
    url: `${apiUrl?.general}Workflow/Contract/__contractId__/TaskAutoAssign`,
    method: apiMethod?.put,
    methodname: 'boUserTaskAutoAssigned',
  },
  autoUnassign: {
    url: `${apiUrl?.general}Workflow/TaskAutoUnassign`,
    method: apiMethod?.put,
    methodname: 'autoUnassign',
  },
  getTaskReservations: {
    url: `${apiUrl?.general}TaskReservation/GetTaskReservations`,
    method: apiMethod?.post,
    methodname: 'getTaskReservations',
  },
  createTaskReservation: {
    url: `${apiUrl?.general}TaskReservation`,
    method: apiMethod?.post,
    methodname: 'createTaskReservation',
  },
  updateTaskReservation: {
    url: `${apiUrl?.general}TaskReservation`,
    method: apiMethod?.put,
    methodname: 'updateTaskReservation',
  },
  deleteTaskReservation: {
    url: `${apiUrl?.general}TaskReservation/__taskReservationId__`,
    method: apiMethod?.delete,
    methodname: 'deleteTaskReservation',
  },
  getTaskReservationById: {
    url: `${apiUrl?.general}TaskReservation/__taskReservationId__`,
    method: apiMethod?.get,
    methodname: 'getTaskReservationById',
  },
  getFourteenDayLetterTask: {
    repReviewUrl: `${apiUrl?.general}Workflow/Contract/__ContractId__/GetWorkflowCase14DayLetterReviewTasks`,
    workFlowUrl: `${apiUrl?.general}Workflow/Contract/__ContractId__/GetWorkflowCase14DayLetterReviewTask`,
    method: apiMethod?.post,
    methodname: 'fourteenDayLetterTask',
  },
  hotspot: {
    saveHotspot: {
      url: `${apiUrl?.general}HotSpot`,
      method: apiMethod?.post,
      methodname: 'saveHotspot',
    },
    getLocationHotspot: {
      url: `${apiUrl?.general}HotSpot/Contract/__contractId__/Location`,
      method: apiMethod?.get,
      methodname: 'Locations',
    },
    getLocationZoneHotspot: {
      url: `${apiUrl?.general}HotSpot/Contract/__contractId__/Zone`,
      method: apiMethod?.get,
      methodname: 'Locations',
    },
    getHostSpotList: {
      url: `${apiUrl?.general}HotSpot/Contract/__contractId__/HotSpots`,
      method: apiMethod?.post,
      methodname: 'getHostSpotList',
    },
    deleteHotspot: {
      url: `${apiUrl?.general}HotSpot`,
      method: apiMethod?.delete,
      methodname: 'deleteHotspot',
    },
    exportHotspot: {
      url: `${apiUrl?.general}HotSpot/Contract/__contractId__/Export`,
      method: apiMethod?.post,
      methodname: 'exportHotspot',
    },
    getHostSpotEdit: {
      url: `${apiUrl?.general}HotSpot/__hotSpotId__/Contract/__contractId__`,
      method: apiMethod?.get,
      methodname: 'getHostSpotEdit',
    },
  },
  trackingAccess: {
    getTrackingAccessList: {
      url: `${apiUrl?.general}CEOOfficerTrack/TrackingAccess/Contract/__contractId__`,
      method: apiMethod?.post,
      methodname: 'getTrackingAccessList',
    },
    updateTrackingAccess: {
      url: `${apiUrl?.general}CEOOfficerTrack/Contract/__contractId__`,
      method: apiMethod?.put,
      methodname: 'updateTrackingAccess',
    },
  },
  airaConfiguration: {
    reason: {
      getReasonByContraventionCodes: {
        url: `${apiUrl?.general}Reason/Contract/__contractId__/ReasonByContraventionCodes`,
        method: apiMethod?.post,
        methodname: 'getReasonByContraventionCodes',
      },
      getReasonByContractId: {
        url: `${apiUrl?.general}Reason/Contract/__contractId__/Reasons`,
        method: apiMethod?.get,
        methodname: 'getReasonByContractId',
      },
      getSubReasons: {
        url: `${apiUrl?.general}SubReason/Reason/__reasonId__/SubReasons`,
        method: apiMethod?.get,
        methodname: 'getSubReasons',
      },
      addReason: {
        url: `${apiUrl?.general}Reason`,
        method: apiMethod?.post,
        methodname: 'addReason',
      },
      reasonExport: {
        url: `${apiUrl?.general}Reason/Export`,
        method: apiMethod?.post,
        methodname: 'reasonExport',
      },
      deleteReason: {
        url: `${apiUrl?.general}Reason/Delete`,
        method: apiMethod?.put,
        methodname: 'deleteReason',
      },
      reasonClone: {
        url: `${apiUrl?.general}Reason/Clone`,
        method: apiMethod?.post,
        methodname: 'reasonClone',
      },
      copyAndMoveReason: {
        url: `${apiUrl?.general}Reason/CopyOrMove`,
        method: apiMethod?.post,
        methodname: 'copyAndMoveReason',
      },
    },
    subReason: {
      getSubReasonsByReasonIds: {
        url: `${apiUrl?.general}SubReason/SubReasonsByReasonIds`,
        method: apiMethod?.post,
        methodname: 'getSubReasons',
      },
    },
    question: {
      deleteQuestion: {
        url: `${apiUrl?.general}Question/Delete`,
        method: apiMethod?.put,
        methodname: 'deleteQuestion',
      },
      cloneQuestion: {
        url: `${apiUrl?.general}Question/Clone`,
        method: apiMethod?.post,
        methodname: 'cloneQuestion',
      },
      questionExport: {
        url: `${apiUrl?.general}Question/Export`,
        method: apiMethod?.post,
        methodname: 'questionExport',
      },
      addQuestion: {
        url: `${apiUrl?.general}Question`,
        method: apiMethod?.post,
        methodname: 'addQuestion',
      },
      getQuestion: {
        url: `${apiUrl?.general}Question/__questionId__`,
        method: apiMethod?.get,
        methodname: 'getQuestion',
      },
      updateQuestion: {
        url: `${apiUrl?.general}Question`,
        method: apiMethod?.put,
        methodname: 'updateQuestion',
      },
      searchQuestion: {
        url: `${apiUrl?.general}Question/Contract/__ContractId__/Search`,
        method: apiMethod?.post,
        methodname: 'searchQuestion',
      },
      applyToReason: {
        url: `${apiUrl?.general}Question/ApplyToReason`,
        method: apiMethod?.put,
        methodname: 'applyToReason',
      },
      getQuestionsBySubReasonIds: {
        url: `${apiUrl?.general}SubReason/QuestionsBySubReasonIds`,
        method: apiMethod?.post,
        methodname: 'get Questions by SubReason Ids',
      },
    },
    reasonList: {
      getReasonList: {
        url: `${apiUrl?.general}Reasons`,
        method: apiMethod?.post,
        methodname: 'getReasonList',
      },
      setGridreasonColumnSetting: {
        url: `${apiUrl?.general}AiraGridSetting/ColumnSetting`,
        method: apiMethod?.post,
        methodname: 'setGridColumnSetting',
      },
      getGridreasonColumnSetting: {
        url: `${apiUrl?.general}AiraGridSetting/__gridName__/Contract/__contractId__/Column`,
        method: apiMethod?.get,
        methodname: 'getGridColumnSetting',
      },
      getGridreasonColumn: {
        url: `${apiUrl?.general}AiraGridSetting/__gridName__/Column`,
        method: apiMethod?.get,
        methodname: 'getGridColumn',
      },
      getReasonById: {
        url: `${apiUrl?.general}Reason/__reasonId__`,
        method: apiMethod?.get,
        methodname: 'getReasonById',
      },
    },
    questionList: {
      getQuestionList: {
        url: `${apiUrl?.general}Question/Questions`,
        method: apiMethod?.post,
        methodname: 'getQuestionList',
      },
    },
    pcnType: {
      getPcnTypeList: {
        url: `${apiUrl?.general}PcnType/PcnTypes`,
        method: apiMethod?.post,
        methodname: 'getPcnTypeList',
      },
      addPcnType: {
        url: `${apiUrl?.general}PcnType`,
        method: apiMethod?.post,
        methodname: 'addPcnType',
      },
      deletePcnType: {
        url: `${apiUrl?.general}PCNType/Delete`,
        method: apiMethod?.put,
        methodname: 'deletePcnType',
      },
      clonePcnType: {
        url: `${apiUrl?.general}PCNType/Clone`,
        method: apiMethod?.post,
        methodname: 'clonePcnType',
      },
      exportTeam: {
        url: `${apiUrl?.general}PCNType/Export`,
        method: apiMethod?.post,
        methodname: 'exportPCNType',
      },
    },
    teamCreation: {
      getTeamCreationList: {
        url: `${apiUrl?.general}Teams`,
        method: apiMethod?.post,
        methodname: 'getTeamCreationList',
      },
      addTeam: {
        url: `${apiUrl?.general}Team`,
        method: apiMethod?.post,
        methodname: 'addTeam',
      },
      editTeam: {
        url: `${apiUrl?.general}Team`,
        method: apiMethod?.put,
        methodname: 'updateTeam',
      },
      getTeam: {
        url: `${apiUrl?.general}Team/__teamId__`,
        method: apiMethod?.get,
        methodname: 'getTeam',
      },
      deleteTeam: {
        url: `${apiUrl?.general}Team/Delete`,
        method: apiMethod?.put,
        methodname: 'deleteTeam',
      },
      exportTeam: {
        url: `${apiUrl?.general}Team/Export`,
        method: apiMethod?.post,
        methodname: 'exportTeam',
      },
      memberLookup: {
        url: `${apiUrl?.general}User/Contract/__contractId__/AIRAUsers`,
        method: apiMethod?.post,
        methodname: 'MemberLookup',
      },
      getTeamDetails: {
        url: `${apiUrl?.general}Team/Contract/__contractId__/Team/__teamId__/TeamDetails`,
        method: apiMethod?.get,
        methodname: 'getTeamDetails',
      },
      getTeamMembersDetails: {
        url: `${apiUrl?.general}Team/Contract/__contractId__/team/__teamId__/Member/__memberId__/TeamMemberDetails`,
        method: apiMethod?.post,
        methodname: 'getTeamMembersDetails',
      },
    },
  },
  watchCases: {
    getListOfWatchCases: {
      url: `${apiUrl?.general}Contract/__contractId__/WatchCases`,
      method: apiMethod?.get,
      methodname: 'getListOfWatchCases',
    },
    watchOrUnwatchCase: {
      url: `${apiUrl?.general}Contract/__contractId__/WatchCase`,
      method: apiMethod?.post,
      methodname: 'watchOrUnwatchCase',
    },
  },
  getLinkCaseForSendCorrespondence: {
    url: `${apiUrl?.general}Case/__caseId__/Contract/__contractId__/CaseBasedOnVRM`,
    method: apiMethod?.post,
    methodname: 'getLinkCaseForSendCorrespondence',
  },

  GetDebtorLinkedCase: {
    url: `${apiUrl?.case}/__caseId__/Contract/__contractId__/Debtor/__debtorId__/GetLinkedDebtorCases`,
    method: apiMethod?.post,
    methodname: 'GetLinkedCase',
  },
  GetDebtorReviewList: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/GetDebtorReview`,
    method: apiMethod?.post,
    methodname: 'GetDebtorReview',
  },
  DebtorReviewCasesCancel: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/DebtorReviewCasesCancel`,
    method: apiMethod?.put,
    methodname: 'DebtorReviewCasesCancel',
  },
  DebtorReviewAddNotes: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/AddNotes`,
    method: apiMethod?.post,
    methodname: 'DebtorReviewAddNotes',
  },
  GetDebtorDetails: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/Debtor/__debtorId__/Details`,
    method: apiMethod?.get,
    methodname: 'GetDebtorDetails',
  },
  GetDebtorCaseDetails: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/Debtor/__debtorId__/CaseDetails`,
    method: apiMethod?.get,
    methodname: 'GetDebtorCaseDetails',
  },
  GetDebtorCaseNotes: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/CaseNotes`,
    method: apiMethod?.post,
    methodname: 'GetDebtorCaseNotes',
  },
  AddDebtorCaseNotes: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/CaseNotes`,
    method: apiMethod?.post,
    methodname: 'AddDebtorCaseNotes',
  },
  AddDebtorNotes: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/AddNotes`,
    method: apiMethod?.post,
    methodname: 'AddDebtorNotes',
  },
  UpdateDebtorContact: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/Debtor/__debtorId__/UpdateContact`,
    method: apiMethod?.put,
    methodname: 'UpdateDebtorContact',
  },
  DebtorReviewExport: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/Export/`,
    method: apiMethod?.get,
    methodname: 'DebtorReviewExport',
  },

  GetDebtorNotes: {
    url: `${apiUrl?.general}Debtor/__debtorId__/Contract/__contractId__/Notes`,
    method: apiMethod?.get,
    methodname: 'GetDebtorNotes',
  },
  GetDebtorDetails: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/Debtor/__debtorId__/Details`,
    method: apiMethod?.get,
    methodname: 'GetDebtorDetails',
  },
  GetDebtorCaseDetails: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/Debtor/__debtorId__/CaseDetails`,
    method: apiMethod?.get,
    methodname: 'GetDebtorCaseDetails',
  },
  GetDebtorcontacted: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/Debtor/__debtorId__/UpdateContact`,
    method: apiMethod?.put,
    methodname: 'GetDebtorcontacted',
  },
  copyFileCaseList: {
    url: `${apiUrl?.general}Case/__caseId__/CopyFiles`,
    method: apiMethod?.post,
    methodname: 'copyFileCaseList',
  },
  copyFileLinkedCase: {
    url: `${apiUrl?.general}Case/CopyFiles/LinkedCases`,
    method: apiMethod?.post,
    methodname: 'copyFileLinkedCase',
  },
  saveCopyAttachmentFile: {
    url: `${apiUrl?.general}Case/__caseId/Contract/__contractId__/CopyAttachmentFile`,
    method: apiMethod?.post,
    methodname: 'saveCopyAttachmentFile',
  },
  getDebtorLinkedCaseCount: {
    url: `${apiUrl?.general}Debtor/__debtorId__/Case/__caseId__/Contract/__contractId__/DebtorLinkedCaseCount`,
    method: apiMethod?.get,
    methodname: 'getDebtorLinkedCaseCount',
  },
  warrantReview: {
    getWarrantReviewList: {
      url: `${apiUrl?.general}Warrant/Contract/__ContractId__/WarrantReviews`,
      method: apiMethod?.post,
      methodname: 'getWarrantReviewList',
    },
    cancelCase: {
      url: `${apiUrl?.general}Warrant/Contract/__ContractId__/WarrantReviewCasesCancel`,
      method: apiMethod?.put,
      methodname: 'cancelCase',
    },
  },
  postAIRAManagerloginTime: {
    url: `${apiUrl?.general}user/LastLogin`,
    method: apiMethod?.put,
    methodname: 'postAIRAManagerloginTime',
  },
  getPermissionTypeData: {
    url: `${apiUrl?.general}ContractSetting/PermissionType`,
    method: apiMethod?.get,
    methodname: 'getPermissionTypeData',
  },
  saveContractPermissionType: {
    url: `${apiUrl?.general}ContractSetting/PermissionType`,
    method: apiMethod?.post,
    methodname: 'saveContractPermissionType',
  },
  createPermissionTypeAndModule: {
    url: `${apiUrl?.general}Permission/CreatePermissionTypeAndModule`,
    method: apiMethod?.post,
    methodname: 'createPermissionTypeAndModule',
  },
  preCases: {
    getListOfPreCases: {
      url: `${apiUrl?.general}PreCase/Contract/__contractId__/GetPreCaseList`,
      method: apiMethod?.post,
      methodname: 'getListOfPreCases',
    },
  },
  preCases: {
    getListOfPreCases: {
      url: `${apiUrl?.general}PreCase/Contract/__contractId__/GetPreCaseList`,
      method: apiMethod?.post,
      methodname: 'getListOfPreCases',
    },
    createPreCase: {
      url: `${apiUrl?.general}PreCase/Contract/__contractId__/CreatePrecase`,
      method: apiMethod?.post,
      methodname: 'createPreCase',
    },
    getById: {
      url: `${apiUrl?.general}PreCase/__preCaseId__/GetPreCase`,
      method: apiMethod?.get,
      methodname: 'get PreCase by ID',
    },
    action: {
      url: `${apiUrl?.general}PreCase/__preCaseId__/Contract/__contractId__/UpdatePrecase`,
      method: apiMethod?.post,
      methodname: 'action on PreCase',
    },
    getAttachmentList: {
      url: `${apiUrl?.general}PreCase/__preCaseId__/Contract/__contractId__/GetPreCaseAttachmentList`,
      method: apiMethod?.post,
      methodname: 'get Attachment List',
    },
    getOffenceType: {
      url: `${apiUrl?.general}Contract/OffenceType`,
      method: apiMethod?.get,
      methodname: 'get Offence Type',
    },
  },
  reportConfiguration: {
    saveReportConfiguration: {
      url: `${apiUrl?.general}Reporting/Contract/_ContractId_/Reporting`,
      method: apiMethod?.post,
      methodname: 'Save report configuraiton',
    },
    getReportDetails: {
      url: `${apiUrl?.general}Reporting/Contract/_ContractId_/ReportingDetails`,
      method: apiMethod?.get,
      methodname: 'Getting Report Details',
    },
    getOrgReportDetails: {
      url: `${apiUrl?.general}Reporting/Organisation/__organisationId__/OrganisationReportingDetails`,
      method: apiMethod?.get,
      methodname: 'Getting org Report Details',
    },
    getReportRoles: {
      url: `${apiUrl?.general}/Reporting/ReportingRoles`,
      method: apiMethod?.get,
      methodname: 'Getting report roles',
    },
  },
  evidenceChecklist: {
    getExistingDocuments: {
      url: `${apiUrl?.general}Workflow/Contract/__contractId__/Case/__caseId__/EvidenceChecklist`,
      method: apiMethod?.get,
      methodname: 'getExistingDocuments',
    },
    uploadAdditionDocument: {
      url: `${apiUrl?.general}Workflow/AdditionalEvidenceUpload`,
      method: apiMethod?.post,
      methodname: 'uploadAdditionDocument',
    },
    submitEvidenceChecklist: {
      url: `${apiUrl?.general}Workflow/EvidenceCheckListSubmit`,
      method: apiMethod?.post,
      methodname: 'submitEvidenceChecklist',
    },
    deleteEvidenceFile: {
      url: `${apiUrl?.general}Workflow/File/__fileName__/AdditionalEvidenceDelete`,
      method: apiMethod?.delete,
      methodname: 'deleteEvidenceFile',
    },
  },
  printAdmin: {
    getListOfPrintAdmin: {
      url: `${apiUrl?.general}PrintBatch/Contract/__contractId__/PrintAdmin`,
      method: apiMethod?.post,
      methodname: 'getListOfPrintAdmin',
    },
    generateNewBatch: {
      url: `${apiUrl?.general}PrintBatch/Contract/__contractId__/PrintType/__printType__/ManualPrintBatch`,
      method: apiMethod?.post,
      methodname: 'generateNewBatch',
    },
  },
  caseLock: {
    getCaseLocks: {
      url: `${apiUrl?.general}CaseLocks`,
      method: apiMethod?.post,
      methodname: 'getCaseLocks',
    },
    lockCase: {
      url: `${apiUrl?.general}CaseLock`,
      method: apiMethod?.put,
      methodname: 'lockCase',
    },
    unlockCase: {
      url: `${apiUrl?.general}CaseLock`,
      method: apiMethod?.put,
      methodname: 'unlockCase',
    },
    getContractsByOrganisation: {
      url: `${apiUrl?.general}CaseLock/ContractSelectByOrganisation`,
      method: apiMethod?.post,
      methodname: 'getContractsByOrganisation',
    },
    getCaseNumbersByContract: {
      url: `${apiUrl?.general}CaseLock/LockedCaseSelectByContract`,
      method: apiMethod?.post,
      methodname: 'getCaseNumbersByContract',
    },
  },
  organisationWidgets: {
    getOrganisationWidgets: {
      url: `${apiUrl?.general}Contract/OrganisationWidgets`,
      method: apiMethod?.get,
      methodname: 'getOrganisationWidgets',
    },
  },
  getContractsByContractType: {
    url: `${apiUrl?.general}Contract/ContractsByContractType`,
    method: apiMethod?.post,
    methodname: 'getContractsByContractType',
  },
  getDiscardReasons: {
    url: `${apiUrl?.general}DiscardReasons`,
    method: apiMethod?.post,
    methodname: 'getDiscardReasons',
  },
  getAllObservation: {
    url: `${apiUrl?.general}Observation/GetAllObservation`,
    method: apiMethod?.post,
    methodname: 'getAllObservation',
  },
  getCCTVLocationsByContract: {
    url: `${apiUrl?.general}Location/Contract/__contractId__/CCTVLocation`,
    method: apiMethod?.get,
    methodname: 'getCCTVLocationsByContract',
  },
  getCCTVSiteLookup: {
    url: `${apiUrl?.general}Observation/GetCCTVSiteLookup/__contractId__`,
    method: apiMethod?.get,
    methodname: 'getCCTVSiteLookup',
  },
  lastActivity: {
    url: `${apiUrl?.general}Workflow/LastActivity`,
    method: apiMethod?.post,
    methodname: 'lastActivity',
  },
  exportActiveObservations: {
    url: `${apiUrl?.general}Observation/Contract/__contractId__/ActiveExport`,
    method: apiMethod?.get,
    methodname: 'exportActiveObservations',
  },
  exportDiscardedObservations: {
    url: `${apiUrl?.general}Discard/Contract/__contractId__/Export`,
    method: apiMethod?.get,
    methodname: 'exportDiscardedObservations',
  },
  exportOnHoldObservations: {
    url: `${apiUrl?.general}Observation/Contract/__contractId__/OnHoldExport`,
    method: apiMethod?.get,
    methodname: 'exportOnHoldObservations',
  },
  exportDiscardReasons: {
    url: `${apiUrl?.general}DiscardReasons/Export`,
    method: apiMethod?.get,
    methodname: 'exportDiscardReasons',
  },
  getContractsByOrganisation: {
    url: `${apiUrl?.general}Contract/ContractsByOrganisation`,
    method: apiMethod?.post,
    methodname: 'getContractsByOrganisation',
  },
  addDiscardReason: {
    url: `${apiUrl?.general}DiscardReason`,
    method: apiMethod?.post,
    methodname: 'addDiscardReason',
  },
  updateDiscardReason: {
    url: `${apiUrl?.general}DiscardReasons`,
    method: apiMethod?.put,
    methodname: 'updateDiscardReason',
  },
  deleteDiscardReasons: {
    url: `${apiUrl?.general}DiscardReasons`,
    method: apiMethod?.delete,
    methodname: 'deleteDiscardReasons',
  },
  discardReasonSampleDownload: {
    url: `${apiUrl?.general}DiscardReasons/CancelReason/Download`,
    method: apiMethod?.post,
    methodname: 'discardReasonSampleDownload',
  },
  discardReasonFileUpload: {
    url: `${apiUrl?.general}DiscardReasons/Upload`,
    method: apiMethod?.post,
    methodname: 'discardReasonFileUpload',
  },
  getDiscardReasonErrorData: {
    url: `${apiUrl?.general}DiscardReasons/GetDiscardReasonsErrors`,
    method: apiMethod?.post,
    methodname: 'getDiscardReasonErrorData',
  },
  discardReasonFileUploadSummary: {
    url: `${apiUrl?.general}DiscardReasons/ValidationStatus`,
    method: apiMethod?.post,
    methodname: 'discardReasonFileUploadSummary',
  },
  discardReasonErrorDataExport: {
    url: `${apiUrl?.general}DiscardReasons/GetDiscardReasonsErrorsExport`,
    method: apiMethod?.post,
    methodname: 'discardReasonErrorDataExport',
  },
  downloadSampleFile: {
    url: `${apiUrl?.general}template/Download`,
    method: apiMethod?.post,
    methodname: 'downloadSampleFile',
  },
  getOrgFavouriteReportList: {
    url: `${apiUrl?.general}ReportFavourite/Organisation/__organisationId__/OrganisationReportDetails`,
    method: apiMethod?.get,
    methodname: 'getOrgFavouriteReportList',
  },
  addOrgFavouriteReport: {
    url: `${apiUrl?.general}ReportFavourite/Organisation/__organisationId__/WorkSpace/__WorkSpaceId__/OrganisationReportFavourite`,
    method: apiMethod?.post,
    methodname: 'addOrgFavouriteReport',
  },
  removeOrgFavouriteReport: {
    url: `${apiUrl?.general}ReportFavourite/Organisation/__organisationId__/WorkSpace/__WorkSpaceId__/OrganisationDeleteReportFavourite`,
    method: apiMethod?.delete,
    methodname: 'removeOrgFavouriteReport',
  },
  addFavouriteOrganisation: {
    url: `${apiUrl?.general}Organisation/__organisationId__/Favourite`,
    method: apiMethod?.post,
    methodname: 'addFavouriteOrganisation',
  },
  removeFavouriteOrganisation: {
    url: `${apiUrl?.general}Organisation/__organisationId__/Favourite`,
    method: apiMethod?.delete,
    methodname: 'removeFavouriteOrganisation',
  },
  addNonWorkingDay: {
    url: `${apiUrl?.general}NonWorkingDay`,
    method: apiMethod?.post,
    methodname: 'addNonWorkingDay',
  },
  deleteNonWorkingDay: {
    url: `${apiUrl?.general}NonWorkingDays/__nonWorkingDayId__`,
    method: apiMethod?.delete,
    methodname: 'deleteNonWorkingDay',
  },
  getNonWorkingDays: {
    url: `${apiUrl?.general}NonWorkingDays`,
    method: apiMethod?.post,
    methodname: 'getNonWorkingDays',
  },
  GetByOrgAndTypeContractList: {
    url: `${apiUrl?.general}Contract/Organisation/__organisationId__/PCNContract`,
    method: apiMethod?.get,
    methodname: 'getNonWorkingDays',
  },
  GetByOrgAndFpnTypeContractList: {
    url: `${apiUrl?.general}Contract/Organisation/__organisationId__/FPNContract`,
    method: apiMethod?.get,
    methodname: 'getNonWorkingDays',
  },
  nonWorkingDayFileUpload: {
    url: `${apiUrl?.general}NonWorkingDays/Upload`,
    method: apiMethod?.post,
    methodname: 'nonWorkingDayFileUpload',
  },
  getNonWorkingDayErrorData: {
    url: `${apiUrl?.general}NonWorkingDays/GetNonWorkingDaysErrors`,
    method: apiMethod?.post,
    methodname: 'getNonWorkingDayErrorData',
  },
  nonWorkingDayFileUploadSummary: {
    url: `${apiUrl?.general}NonWorkingDays/ValidationStatus`,
    method: apiMethod?.post,
    methodname: 'nonWorkingDayFileUploadSummary',
  },
  nonWorkingDayErrorDataExport: {
    url: `${apiUrl?.general}NonWorkingDays/GetNonWorkingDaysErrorsExport`,
    method: apiMethod?.post,
    methodname: 'nonWorkingDayErrorDataExport',
  },
  getLinkCaseForAddNotes: {
    url: `${apiUrl?.general}Case/__caseId__/Contract/__contractId__/CaseBasedOnNotes`,
    method: apiMethod?.post,
    methodname: 'getLinkCaseForAddNotes',
  },
  addNonWorkingDay: {
    url: `${apiUrl?.general}NonWorkingDay`,
    method: apiMethod?.post,
    methodname: 'addNonWorkingDay',
  },
  deleteNonWorkingDay: {
    url: `${apiUrl?.general}NonWorkingDays/__nonWorkingDayId__`,
    method: apiMethod?.delete,
    methodname: 'deleteNonWorkingDay',
  },
  getNonWorkingDays: {
    url: `${apiUrl?.general}NonWorkingDays`,
    method: apiMethod?.post,
    methodname: 'getNonWorkingDays',
  },
  nonWorkingDayFileUpload: {
    url: `${apiUrl?.general}NonWorkingDays/Upload`,
    method: apiMethod?.post,
    methodname: 'nonWorkingDayFileUpload',
  },
  getNonWorkingDayErrorData: {
    url: `${apiUrl?.general}NonWorkingDays/GetNonWorkingDaysErrors`,
    method: apiMethod?.post,
    methodname: 'getNonWorkingDayErrorData',
  },
  nonWorkingDayFileUploadSummary: {
    url: `${apiUrl?.general}NonWorkingDays/ValidationStatus`,
    method: apiMethod?.post,
    methodname: 'nonWorkingDayFileUploadSummary',
  },
  nonWorkingDayErrorDataExport: {
    url: `${apiUrl?.general}NonWorkingDays/GetNonWorkingDaysErrorsExport`,
    method: apiMethod?.post,
    methodname: 'nonWorkingDayErrorDataExport',
  },
  downloadSampleFile: {
    url: `${apiUrl?.general}template/Download`,
    method: apiMethod?.post,
    methodname: 'downloadSampleFile',
  },
  getBoManagerLocationZoneValue: {
    url: `${apiUrl?.general}Contract/AdditionalDetail`,
    method: apiMethod?.get,
    methodname: 'getBoManagerLocationZoneValue',
  },
  getCaseExtendedData: {
    url: `${apiUrl?.case}/__caseId__/CaseAdditionalDetail`,
    method: apiMethod?.get,
    methodname: 'getCaseExtendedData',
  },
  getPANdDetails: {
    url: `${apiUrl?.case}/_CaseId_/GetPandDInfo`,
    method: apiMethod?.get,
    methodname: 'getPANdDetails',
  },
  getCaseExtendedData: {
    url: `${apiUrl?.case}/__caseId__/CaseAdditionalDetail`,
    method: apiMethod?.get,
    methodname: 'getCaseExtendedData',
  },
  infoRequests: {
    url: `${apiUrl?.general}Workflow/__ContractId__/InfoRequests`,
    method: apiMethod?.post,
    methodname: 'infoRequests',
  },
  caseOverViewExport: {
    url: `${apiUrl?.general}Contract/__contractId__/CaseOverview/Export`,
    method: apiMethod?.get,
    methodname: 'caseOverViewExport',
  },
  DebtorReviewSidePanelAddNotes: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/AddNotes`,
    method: apiMethod?.post,
    methodname: 'DebtorReviewSidePanelAddNotes',
  },
  GetDebtorCaseNotes: {
    url: `${apiUrl?.general}Debtor/Contract/__contractId__/CaseNotes`,
    method: apiMethod?.post,
    methodname: 'GetDebtorCaseNotes',
  },
  postCaseContactAddress: {
    url: `${apiUrl?.case}/__caseId__/Contracts/__contractId__/ContactAddress`,
    method: apiMethod?.post,
    methodname: 'Post Case ContactAddress',
  },
  CPZ: {
    getCPZ: {
      url: `${apiUrl?.general}CPZ/GetAllCPZ`,
      method: apiMethod?.post,
      methodname: 'GetAllCPZ',
    },
    updateCPZ: {
      url: `${apiUrl?.general}CPZ`,
      method: apiMethod?.put,
      methodname: 'UpdateCPZ',
    },
    deleteCPZ: (id) => ({
      url: `${apiUrl?.general}CPZ/${id}`,
      method: apiMethod?.delete,
      methodname: 'DeleteCPZ',
    }),
    createCPZ: {
      url: `${apiUrl?.general}/CPZ`,
      method: apiMethod?.post,
      methodname: 'CreateCPZ',
    },

    cpzSampleDataDownload: {
      url: `${apiUrl?.general}Template/Download`,
      method: apiMethod?.post,
      methodname: 'sampleDownload',
    },
    cpzUpload: {
      url: `${apiUrl?.general}CPZ/Upload`,
      method: apiMethod?.post,
      methodname: 'CPZ',
    },
    uploadedFileErrorsExport: {
      url: `${apiUrl?.general}CPZ/GetCPZErrorsExport`,
      method: apiMethod?.post,
      methodname: 'uploadedFileErrorsExport',
    },
    getCPZErrors: {
      url: `${apiUrl?.general}CPZ/GetCPZErrors`,
      method: apiMethod?.post,
      methodname: 'GetCPZErrors',
    },
    validationStatus: {
      url: `${apiUrl?.general}CPZ/ValidationStatus`,
      method: apiMethod?.post,
      methodname: 'ValidationStatus',
    },

    exportCPZ: {
      url: `${apiUrl?.general}CPZ/Export`,
      method: apiMethod?.get,
      methodname: 'ExportCPZ',
    },
  },
  UserPreference: {
    getQuickSearchColumns: {
      url: `${apiUrl?.general}UserPreference/Contract/__ContractId__/QuickSearchColumns`,
      method: apiMethod?.get,
      methodname: 'getQuickSearchColumns',
    },
    updateQuickSearchColumns: {
      url: `${apiUrl?.general}UserPreference/Contract/__ContractId__/QuickSearchColumns`,
      method: apiMethod?.put,
      methodname: 'updateQuickSearchColumns',
    },
  },
  enforcementMap: {
    getMetrosMap: {
      url: `${apiUrl?.general}Map/MetrosMap`,
      method: apiMethod?.get,
      methodname: 'getMetrosMap',
    },
    getTodayObservations: {
      url: `${apiUrl?.general}Contract/__contractId__/TodayObservations`,
      method: apiMethod?.get,
      methodname: 'getTodayObservations',
    },
    getTodayCases: {
      url: `${apiUrl?.general}Contract/__contractId__/TodayCases`,
      method: apiMethod?.get,
      methodname: 'getTodayCases',
    },
    getActiveDefects: {
      url: `${apiUrl?.general}ManualReportFault/Contract/__contractId__/List/Active`,
      method: apiMethod?.get,
      methodname: 'getActiveDefects',
    },
  },
  attachmentRotation: {
    url: `${apiUrl?.case}/Attachment/__AttachmentId__/Rotation`,
    method: apiMethod?.put,
    methodname: 'rotateAttachment',
  },
  getFaults: {
    url: `${apiUrl?.general}ManualReportFault/Contract/__contractId__/List`,
    method: apiMethod?.post,
    methodname: 'getFaults',
  },
  updateFaultStatus: {
    url: `${apiUrl?.general}ManualReportFault/Contract/__contractId__`,
    method: apiMethod?.put,
    methodname: 'updateFaultStatus',
  },
  getReportStatusLookup: {
    url: `${apiUrl?.general}ContractSetting/ReportStatusLookup`,
    method: apiMethod?.get,
    methodname: 'getReportStatusLookup',
  },
  integrationFileTransfer: {
    getIntegrationFileTransfers: {
      url: `${apiUrl?.general}MftDashboard/Contract`,
      method: apiMethod?.post,
      methodname: 'getIntegrationFileTransfers',
    },
  },

  appealPin: {
    getAppealPinDetails: {
      url: `${apiUrl?.case}/__caseId__/AppealPIN/GetAppealPIN`,
      method: apiMethod?.get,
      methodname: 'getAppealPinDetails',
    },
    generateAppealPin: {
      url: `${apiUrl?.case}/__caseId__/AppealPIN/GenerateAppealPIN`,
      method: apiMethod?.post,
      methodname: 'generateAppealPin',
    },
    saveAppealPin: {
      url: `${apiUrl?.case}/__caseId__/AppealPIN`,
      method: apiMethod?.put,
      methodname: 'saveAppealPin',
    },
  },
  captureUserActivity: {
    url: `${apiUrl?.general}Workflow/CaptureUserActivity`,
    method: apiMethod?.post,
    methodname: 'captureUserActivity',
  },
  getPrivateLandDetails: {
    url: `${apiUrl?.general}Observation/Contract/__contractId__/BreachDetails`,
    method: apiMethod?.post,
    methodname: 'getPrivateLandDetails',
  },
  abandonedVehicle: {
    getEnquiryList: {
      url: `${apiUrl?.general}AbandonedVehicle/Contract/__contractId__/List`,

      method: apiMethod?.post,
      methodname: 'getAbandonedVehicleEnquiryList',
    },
    getEnquiryDetails: {
      url: `${apiUrl?.general}AbandonedVehicle/Contract/__contractId__/__enquiryRecordId__`,
      method: apiMethod?.get,
      methodname: 'getAbandonedVehicleEnquiryDetails',
    },
    lookupByVrm: {
      url: `${apiUrl?.general}AbandonedVehicle/Contract/__contractId__/Lookup`,
      method: apiMethod?.post,
      methodname: 'abandonedVehicleLookupByVrm',
    },
  },
}

export default APIEndPoints
